import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TemplateRef } from '@angular/core';
import { TaskService } from '../services/task.services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Observable, Subject, fromEvent } from 'rxjs';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { SelectionModel } from '@angular/cdk/collections';
import * as moment from 'moment';
import { I, N } from '@angular/cdk/keycodes';

import { Clipboard } from "@angular/cdk/clipboard"
import { ThrowStmt, flatten } from '@angular/compiler';
import { AddTaskTempCategoryComponent } from 'src/app/middleware/common/addTaskTempCategory/addTaskTempCategory.component';
import { CoreService } from '../../core/services/coreService/core.service';
import { FormsService } from '../../eSignature/services/forms.service';
import { DatePipe } from '@angular/common';
import { MatRadioChange } from '@angular/material/radio';
import { map, tap } from 'rxjs/operators';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { AddUpdateProcessStageComponent } from 'src/app/middleware/common/addupdateProcessStage/addupdateProcessStage.component';

@Component({
  selector: 'app-task-dashboard',
  templateUrl: './task-dashboard.component.html',
  styleUrls: ['./task-dashboard.component.scss'],
  providers: [DatePipe],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})


export class TaskDashboardComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  ShowNoRecordFound: boolean = false;
  taskList: any = [] = [];
  subTaskList: any = [] = [];

  value: string = '';
  showCreateTask: boolean = false;
  showTaskDetail: boolean = false;
  showProcess: boolean = false;
  showmyDrive: boolean = true;
  showSub: boolean = false;
  showSub1: boolean = false;

  dataSource: any = [] = [];

  userToken: any;
  decodedUserData: any;
  encryptedUserToken: any;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = [];

  pageSizeOptions: number[] = [10, 20, 50, 100];
  paginatorTotalLength: any;
  pageModelData = {
    pageIndex: 1,
    pageSize: 30,
    searchValue: '',
  };

  pageSize:number= 30;
  pageIndex:number= 1;
  taskId: number = 0;

  taskListFolder: any = [] = [];
  taskListFolderSharedWithMe: any = [] = [];
  selection = new SelectionModel<any>(true, []);
  taskStatusList: any = [] = [];

  selectedTaskListID=0;
  selectedTaskListFolderID=0;
  dueDatetext: string = 'This Week';
  statustext: string = 'Status';
  myTaskText: string = 'Assigned to me';
  preorityArray: any = [];
  isOverDue: boolean = false;
  isDuedate: boolean = false;
  dateFrom: any = null;
  dateTo: any = null;
  preoritytext: string = "Priority";
  IsAssignedToMe: boolean = true;
  IsAssignedToMyRole: boolean = false;
  IsAllTask: boolean = false;
  IsCreatedByMe: boolean = false;
  isMyTaskFilterSelected: boolean = false;
  completedTaskStatusID: any = 0;
  moduleNames: string = "Task";
  statustype: number = 0;
  attachedEntityID: any = 0;
  entityTypeAttached: any;
  authenticationMobile: any;
  userFullName: any = '';
  userEmailForCode: any;
  showMobile: boolean;
  verifyToken: any = 0;
  showEmail: boolean;
  tokenValue: any;
  isEmailVerified: boolean;
  isEntityIDAttached: boolean;
  isEntityAttached: boolean = false;
  rolesAsssign: any[] = [];
  isOrganizationAdmin: boolean = false;
  isOfficeAdmin: boolean = false;
  isSuperAdmin: boolean = false;
  mainModuleName:string="Task";
  addtaskTemplateName = "";

  AttachChecked:boolean=false;
  AssigneeChecked:boolean=false;
  NotifyChecked:boolean=false;

 @ViewChildren('categoryList') categoryList:ElementRef
 CoreShowName: string = '';
 ContactShowName: string = '';
 CompanyShowName: string = '';
 menuModulesList:any=[]=[];

  //displayedColumnsg: string[];
  //displayedColumnsgG: string[];

  // dropItem(event: CdkDragDrop<string[]>) {
  //   if (event.previousContainer === event.container) {
  //     moveItemInArray(
  //       event.container.data,
  //       event.previousIndex,
  //       event.currentIndex
  //     );
  //   } else {
  //     transferArrayItem(
  //       event.previousContainer.data,
  //       event.container.data,
  //       event.previousIndex,
  //       event.currentIndex
  //     );
  //   }
  // }

  // getConnectedList(): any[] {
  //   return this.taskListFolder.map((x) => `${x.taskListFolderID}`);   
  // }

  // dropGroup(event: CdkDragDrop<string[]>) {
  //   moveItemInArray(this.taskListFolder, event.previousIndex, event.currentIndex);   
  // }

  dropItem(event: CdkDragDrop<string[]>) {
    event.item.data.taskGroupId = Number(event.container.id);
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      this.dropTable();
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      this.dropTable();
    }
  }

  getConnectedList(): any[] {
    return this.columns[0].groups.map((x) => `${x.id}`);
    // return this.columns.map((x) => `${x.id}`);
  }

  dropGroup(event: CdkDragDrop<string[]>) {
    //Default Group
    // if(event.item.data.title!='Default Group' && event.currentIndex<(this.columns[0].groups.length-1))
    // {
    moveItemInArray(this.columns[0].groups, event.previousIndex, event.currentIndex);
    var newGroup = [];
    newGroup = this.columns[0].groups.filter(x => x.id > 0);

    var itemList = [];
    if (newGroup.length > 0) {
      //newGroup=newGroup.reverse();
      for (var i = 0, len = newGroup.length; i < len; ++i) {
        var obj = {
          position: i + 1,
          taskGroupID: newGroup[i].id,
        }
        itemList.push(obj);
      }
    }
    //return;
    var taskListIDs:number=0
    if(this.taskListIDSharedWithMe>0){
      taskListIDs=this.taskListIDSharedWithMe;
    }
    if(this.taskListID>0){
      taskListIDs=this.taskListID;
    }
    var ReqModel = {
      taskListID: taskListIDs,//this.taskListID,
      taskGroups: itemList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    };
    this.loaderService.show();
    this.taskService.reorderTaskGroup(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          //this.getTaskByTaskList();
          if(this.taskListIDSharedWithMe>0){
            this.getTaskByTaskListSharedWithMe();
          }else{
            this.getTaskByTaskList();
          }  
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
    // }else{
    //   this.toastr.warning("Can't move default group or any group below default group.");
    // }
  }

  columnsCopy = [
    {
      id: 0,
      title: "",
      groups: [
        // {
        //   id: 1,
        //   title: 'Group 1',
        //   items: [
        //     {
        //       "completedTaskCount": 1,
        //       "inprogressTaskCount": 2,
        //       "taskId": 839,
        //       "taskTitle": "ewqe",
        //       "dueDate": "2022-12-30T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-30T16:12:20.0127548",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 823,
        //       "taskTitle": "Testing add from core",
        //       "dueDate": null,
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-14T15:49:37.5893446",
        //       "parentID": 0,
        //       "status": 0,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 822,
        //       "taskTitle": "Testing add from core",
        //       "dueDate": null,
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-14T15:49:36.6103009",
        //       "parentID": 0,
        //       "status": 0,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },

        //   ],
        // },
        // {
        //   id: 3,
        //   title: 'Group 3',
        //   items: [
        //     {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 820,
        //       "taskTitle": "avv1",
        //       "dueDate": "2022-11-27T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-28T18:12:16.8375494",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 349,
        //       "taskTitle": "test neu cores23445",
        //       "dueDate": "2022-11-25T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-25T18:33:58.1130724",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 348,
        //       "taskTitle": "Testing add from core234",
        //       "dueDate": "2022-11-24T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-25T18:21:26.8596399",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },

        //   ],
        // },
      ],
    },

  ];


  columns = [
    {
      id: 0,
      title: "",
      groups: [
        // {
        //   id: 1,
        //   title: 'Group 1',
        //   items: [
        //     {
        //       "completedTaskCount": 1,
        //       "inprogressTaskCount": 2,
        //       "taskId": 839,
        //       "taskTitle": "ewqe",
        //       "dueDate": "2022-12-30T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-30T16:12:20.0127548",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 823,
        //       "taskTitle": "Testing add from core",
        //       "dueDate": null,
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-14T15:49:37.5893446",
        //       "parentID": 0,
        //       "status": 0,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 822,
        //       "taskTitle": "Testing add from core",
        //       "dueDate": null,
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-14T15:49:36.6103009",
        //       "parentID": 0,
        //       "status": 0,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },

        //   ],
        // },
        // {
        //   id: 3,
        //   title: 'Group 3',
        //   items: [
        //     {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 820,
        //       "taskTitle": "avv1",
        //       "dueDate": "2022-11-27T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-28T18:12:16.8375494",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 349,
        //       "taskTitle": "test neu cores23445",
        //       "dueDate": "2022-11-25T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-25T18:33:58.1130724",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 348,
        //       "taskTitle": "Testing add from core234",
        //       "dueDate": "2022-11-24T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-25T18:21:26.8596399",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },

        //   ],
        // },
      ],
    },

  ];

  taskListArchived = [
    {
      id: 1,
      name: "TaskList",     
    },
    {
      id: 2,
      name: "Single Task",     
    },
  ];

  private destroy$ = new Subject<void>(); // Subject to manage subscription lifecycle
  receivedLinkData: any;
  constructor(private route: ActivatedRoute,private dialog: MatDialog, private loaderService: LoaderService,
    private cdr: ChangeDetectorRef, private _dataSharingService: DataSharingService,
    private router: Router, private reusableClass: ReusableClasses,
    private encryptionAlgo: EncryptionService, private statusConst: StatusConstant,
    private taskService: TaskService, private formBuilder: FormBuilder,
    private toastr: ToastrService, private clipboard: Clipboard, private coreService: CoreService,
    private statusConstant: StatusConstant,
    private formsService: FormsService, private datePipe: DatePipe,private renderer: Renderer2
  ) {
    this.myFormGroup = new FormGroup({});
    this.statusGroup = new FormGroup({});
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }
 
 

  ngOnInit(): void {

    this.menuModulesList = JSON.parse(sessionStorage.getItem('menuModules'));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter(
      (x) => x.mainModuleName == 'Core'
    );
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;     
    }

    SelectedContact = this.menuModulesList.filter(
      (x) => x.mainModuleName == 'Contact'
    );
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;      
    }

    SelectedCompany = this.menuModulesList.filter(
      (x) => x.mainModuleName == 'Company'
    );
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;   
    }

    this.route.queryParams.subscribe(params => {
      if (params['data']) {
        this.receivedLinkData = this.decodeData(params['data']);
        if(this.receivedLinkData.isSharedTasklist==true){
          this.OpenTaskListSharedWithMe(this.receivedLinkData);        
        }else{
          this.OpenTaskList(this.receivedLinkData);         
        }
      }else{
      }
    });

    this.getLoadingData();
    this.getPredefinedaskStatus();
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = [];
    Module = menuModulesList.filter(x => (x.mainModuleName.toLowerCase() == "Task".toLowerCase()) || (x.mainModuleName.toLowerCase() == "New Task".toLowerCase()));
    if (Module.length > 0) {
      //this.Module = Module[0].orgModuleName;
      this.folderId = Module[0].folderID;
    }
    this.getTaskStatus();
    this.setDisplayedColumns();
    this.getTaskList(this.pageModelData);
    this.getTaskListFolders();
    this.GetTasklistFolderSharedWithMe();

    this.getAllFolderFields();
    // this.getTaskByTaskList() ;
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    if (this.rolesAsssign.length > 0) {
      this.isOfficeAdmin = this.rolesAsssign.find(m => m.roleName == 'Office Admin') != undefined;
      this.isOrganizationAdmin = this.rolesAsssign.find(m => m.roleName == 'Organization Admin') != undefined;
      this.isSuperAdmin = this.rolesAsssign.find(m => m.roleName == 'Super Admin') != undefined;
      // var admin=[];
      // // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      // admin= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin
      // || m.roleLevel == RoleLevel.OrganizationAdmin || m.roleLevel == RoleLevel.OfficeAdmin);
      // if(admin.length > 0){
      //    this.showOrgnizationLevelCheckbox=true;
      // }else{
      //   this.showOrgnizationLevelCheckbox=false;
      // }
    }
   
  }

  ngOnDestroy() {
 // Emit a value to trigger unsubscription for all subscriptions using takeUntil
    this.destroy$.next();
    this.destroy$.complete(); // Complete the subject to clean up
  }

  decodeData(encodedData: string): any {
    try {
      return JSON.parse(atob(encodedData)); // Decode Base64 string back to object
    } catch (error) {
      console.error('Decoding failed:', error);
      return null;
    }
  }

  totalTask:number=0;

  getLoadingData() { 
      const content = document.querySelector('.right');
      const scroll$ = fromEvent(content!, 'scroll').pipe(map(() => { return content!.scrollTop; }));
         
      scroll$.subscribe((scrollPos) => {
      let limit = content!.scrollHeight - content!.clientHeight;
      scrollPos = Math.round(scrollPos);
      scrollPos=scrollPos+20;
       if (scrollPos >= limit) {
        if(this.showAddGroupButton==false){
          if(this.IsAssignedToMe == true || this.IsAssignedToMyRole == true ||
            this.IsCreatedByMe == true || this.IsAllTask == true){
              if(this.totalTask != this.taskList.length){
                var number=0;
                number =(number+this.pageIndex);
                this.pageIndex= (number+1);               
                this.getTaskList(this.pageModelData);
                //alert("test");
              }
            }
          }     
        }
     });
  }

  setDisplayedColumns() {
    this.displayedColumns = ["taskTitle", "dueDate", "status", "priority", "Action"];
   }

  getTaskStatus() {
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    this.loaderService.show();
    this.taskService.taskStatus(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskStatusList = this.responseHolder.data;
        
          this.taskStatusList.map(data =>{
            if(data.taskStatusConstantName == 'blocked'){
              data.taskStatusName = 'Stuck';
            }
          });

          let completedTask = this.taskStatusList.find(m => m.taskStatusConstantName == 'completed');
          if (completedTask !== undefined) {
            this.completedTaskStatusID = completedTask.taskStatusID;
          }
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  getStatusVal(e: any) {
    // this.statusID=e.value;
  }

  clearDuedate() {
    this.ShowCustomColumn = false;
    this.taskListIDSharedWithMe = 0;
    this.dueDatetext = 'Due Date';
    this.isDuedate = false;
    this.isOverDue = false;
    this.dateFrom = null;
    this.dateTo = null;
    this.pageIndex=1;
    this.pageSize=30;
    this.totalTask=0;
    if (this.taskListID == 0)
      this.getTaskList(this.pageModelData);
    else
      this.getTaskByTaskListWhenClearFilter();
  }

  clearStatus() {
    this.statustext = 'Status';
    this.statustype = 0;
    //this.isDuedate=false;
    //this.isOverDue=false;
    //this.dateFrom=null;
    //this.dateTo=null;
    if (this.taskListID == 0)
      this.getTaskList(undefined);
    else {
      this.getTaskByTaskListWhenClearFilter();
    }
  }

  clearPreoority() {
    this.ShowCustomColumn = false;
    this.taskListIDSharedWithMe = 0;
    this.preoritytext = "Priority";
    this.preorityArray = [];
    if (this.taskListID == 0)
      this.getTaskList(undefined);
    else
      this.getTaskByTaskListWhenClearFilter();
  }

  clearFilterByMyTask() {
    this.ShowCustomColumn = false;
    this.taskListIDSharedWithMe = 0;
    this.IsAssignedToMe = false;
    this.IsAssignedToMyRole = false;
    this.IsCreatedByMe = false;
    this.IsAllTask = false;
    this.myTaskText = "";
    this.isMyTaskFilterSelected = false;
    this.getTaskList(undefined);
  }

  clearSerachText() {
    this.value = '';
    if (this.taskListID == 0)
      this.getTaskList(undefined);
    else {
      this.getTaskByTaskListWhenClearFilter();
    }
  }

  // getSearchResults1(){
  //   this.taskListIDSharedWithMe=0;
  //   this.ShowNoRecordFound=false;   
  //   this.loaderService.show();
  //   var ReqModel={
  //     "filter": {
  //       IsAssignedToMe:this.IsAssignedToMe,
  //       IsAssignedToMyRole:this.IsAssignedToMyRole,
  //       IsCreatedByMe:this.IsCreatedByMe,
  //       IsAllTask:this.IsAllTask,
  //       "title": this.value,
  //       "description": "",
  //       "attachedTitle": "",
  //       "taskListID": this.taskListID,
  //       TaskListFolderID:this.taskListFolderID,
  //       "createdOn": {
  //         "from": null,
  //         "to": null
  //       },
  //       "assignedOn": {
  //         "from": null,
  //         "to": null
  //       },
  //       "assignees": [
  //         0
  //       ],
  //       "Priority": this.preorityArray,
  //       "byDate": {
  //         "from": this.dateFrom,
  //         "to": this.dateTo
  //       },
  //       isOverDue:this.isOverDue,
  //       "dueDate": this.isDuedate,
  //       "status": this.statustype,
  //       "attachmentType": 0
  //     },
  //      userID: this.currentUser.UID,     
  //      officeID: this.myOfficeID,    
  //      organizationID: Number(this.organizationId),
  //      officeIDList: this.OfficeIDList,
  //      databaseID:this.databaseId
  //     // pageIndex : pageData.pageIndex,
  //     // pageSize :pageData.pageSize
  //   }      
  //   this.taskService.getTaskList(ReqModel).subscribe(response => {
  //     if (response != undefined) {
  //       this.responseHolder = response;
  //       this.loaderService.hide();
  //       if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
  //         this.dataSource = new MatTableDataSource<any>();      
  //         if(ReqModel.filter!=null && ReqModel.filter!=undefined && ReqModel.filter.taskListID==0)  
  //         { 
  //          this.taskList = response.data.tasks.filter(m=>m.isInternal==true);
  //         }
  //         else
  //         {
  //           this.taskList = response.data.tasks;
  //         }


  //         if(response.data.tasks.length > 0){
  //           response.data.tasks.map(state => {                  

  //               this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

  //               if(state.status == 0){
  //                 this.statusGroup.controls["status" + state.taskId].setValue(1);
  //               }else{
  //                 this.statusGroup.controls["status" + state.taskId].setValue(state.status);               
  //               }

  //               this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

  //               if(state.priority == 0){
  //                this.statusGroup.controls["priority" + state.taskId].setValue(1);
  //               }else{
  //                this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
  //               }

  //          })
  //         }


  //         this.dataSource.data =this.taskList;
  //         this.dataSource.sort = this.sort;         
  //         this.columns[0].groups=[{
  //           id: 0,
  //           title: 'Default Group',
  //           dragDisabled:true,
  //           items:this.taskList
  //         }];   
  //         if(this.taskList.length>0){
  //           this.ShowNoRecordFound=false;
  //         }else{
  //           this.ShowNoRecordFound=true;
  //          }    
  //       }
  //       else {
  //         this.ShowNoRecordFound=true;
  //         this.taskList=[];   
  //         this.dataSource.data=[];      
  //         this.loaderService.hide();
  //       }
  //     }
  //     else {
  //       this.paginatorTotalLength=0;      
  //       this.ShowNoRecordFound=true;
  //       this.taskList=[];
  //       this.loaderService.hide();
  //     }
  //   });
  // }

  getSearchResults() {
    if (this.taskListID == 0) {
      this.ShowNoRecordFound = false;
      this.loaderService.show();
      this.pageIndex=1;
      this.pageSize=30;
    //  this.totalTask=0;
      var ReqModel = {
        "paging": {
          "pageSize":  this.pageSize,//pageData.pageSize,
          "pageIndex": this.pageIndex  //pageData.pageIndex,
        },
        IsFilterApply: true,
        "filter": {
          IsAssignedToMe: this.IsAssignedToMe,
          IsAssignedToMyRole: this.IsAssignedToMyRole,
          IsCreatedByMe: this.IsCreatedByMe,
          IsAllTask: this.IsAllTask,
          "title": this.value,
          "description": "",
          "attachedTitle": "",
          "taskListID": this.taskListID,
          TaskListFolderID: this.taskListFolderID,
          "createdOn": {
            "from": null,
            "to": null
          },
          "assignedOn": {
            "from": null,
            "to": null
          },
          "assignees": [
            0
          ],
          "Priority": this.preorityArray,
          "byDate": {
            "from": this.dateFrom,
            "to": this.dateTo
          },
          isOverDue: this.isOverDue,
          "dueDate": this.isDuedate,
          "status": this.statustype,
          "attachmentType": 0
        },
        "isArchived": false,
        taskType: 2, // 0-External, 1-Internal ,2-Both
        userID: this.currentUser.UID,
        officeID: this.myOfficeID,
        organizationID: Number(this.organizationId),
        officeIDList: this.OfficeIDList,
        databaseID: this.databaseId
      }
      this.taskService.getTaskList(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
            this.dataSource = new MatTableDataSource<any>();
            if (ReqModel.filter != null && ReqModel.filter != undefined && ReqModel.filter.taskListID == 0) {
              //this.taskList = response.data.tasks.filter(m => m.isInternal == true);
              this.taskList = response.data.tasks;//.filter(m => m.isInternal == true);
            }
            else {
              this.taskList = response.data.tasks;
            }
            
            if (this.taskList.length > 0) {
              this.taskList.map(state => {
  
                this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));
  
                if (state.status == 0) {
                  this.statusGroup.controls["status" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["status" + state.taskId].setValue(state.status);
                }
  
                this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));
  
                if (state.priority == 0) {
                  this.statusGroup.controls["priority" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
                }
              })
            }
            
            this.taskList.forEach(state => {
              if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
                //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                state.dueDate = state.dueDate+'.000Z';
             }
            });
            this.dataSource.data = this.taskList;
            this.dataSource.sort = this.sort;
            this.columns[0].groups = [{
              id: 0,
              title: 'Default Group',
              dragDisabled: true,
              items: this.taskList
            }];
            if (this.taskList.length > 0) {
              this.ShowNoRecordFound = false;
            } else {
              this.ShowNoRecordFound = true;
            }
          }
          else {
            this.ShowNoRecordFound = true;
            this.taskList = [];
            this.dataSource.data = [];
            this.loaderService.hide();
          }
        }
        else {
          this.paginatorTotalLength = 0;
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.loaderService.hide();
        }
      });
    } else if (this.taskListID > 0) {
      this.ShowNoRecordFound = false;
      this.loaderService.show();
      var ReqModel1 = {
        taskListID: this.taskListID,
        moduleID: this.folderId,
        IsFilterApply: true,
        "filters": {
          Keyword: this.value,
          Priority: this.preorityArray,
          Status: this.statustype,
          isOverDue: this.isOverDue,
          "ByDate": {
            "from": this.dateFrom,
            "to": this.dateTo
          }
        },
        userID: this.currentUser.UID,
        officeID: this.myOfficeID,
        organizationID: Number(this.organizationId),
        officeIDList: this.OfficeIDList,
        databaseID: Number(this.databaseId)
      }
      this.taskService.GetTaskGroupsByTaskList(ReqModel1).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
            this.dataSource = new MatTableDataSource<any>();
            this.myTaskText = response.data.taskListName;
            this.columns = JSON.parse(JSON.stringify(this.columnsCopy));
            if (response.data.taskGroups !== undefined && response.data.taskGroups !== null) {
              response.data.taskGroups = response.data.taskGroups.sort(function (a, b) {
                return a.groupPosition - b.groupPosition;
              });

              const taskFil = response.data.taskGroups.filter(x => x.tasks.length > 0)
              taskFil.map(data => {
                data.tasks.forEach(state => {
                  this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

                  if (state.status == 0) {
                    this.statusGroup.controls["status" + state.taskId].setValue(1);
                  } else {
                    this.statusGroup.controls["status" + state.taskId].setValue(state.status);
                  }
                  this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

                  if (state.priority == 0) {
                    this.statusGroup.controls["priority" + state.taskId].setValue(1);
                  } else {
                    this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
                  }
                  if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
                  // state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                   state.dueDate = state.dueDate+'.000Z';
                 }
                })
              })

              response.data.taskGroups.forEach(tg => {

                if (tg.tasks !== undefined && tg.tasks !== null) {
                  tg.tasks.forEach(ts => {
                    ts.formLink = this.reSetFormURL(ts.taskId, ts.formLink);
                    if (ts.dueDate!=null && ts.dueDate!=undefined && ts.dueDate!="") {
                      ts.dueDate = moment(ts.dueDate).local().format('YYYY-MM-DD');
                   }
                  });
                  tg.tasks = tg.tasks.sort(function (a, b) {
                    return a.position - b.position;
                  });
                }
                this.columns[0].groups.push({
                  id: tg.taskGroupId,
                  title: tg.taskGroupName == "Undefined" ? 'Default Group' : tg.taskGroupName,
                  items: tg.tasks,
                  dragDisabled: tg.taskGroupName == "Undefined" ? true : false,
                  groupPosition: tg.groupPosition,
                  processStageID:tg.processStageID,
                  processStageName:tg.processStageName,
                  isTriggered:tg.isTriggered,
                  groupType:tg.groupType
                });
              });
            }
            this.taskList = response.data.getTaskDetailResponseDTOs;
            this.FieldColumnToogle = response.data.gridSettings;
            this.FieldColumn = response.data.gridSettings;

            if (this.FieldColumn.length > 0) {
              this.FieldColumn = this.FieldColumn.filter(x => x.isDisplay == true);
            }
            if (response.data.taskGroups.length > 0) {
              this.ShowNoRecordFound = false;
            } else {
              this.ShowNoRecordFound = true;
            }
          }
          else {
            this.ShowNoRecordFound = true;
            this.taskList = [];
            this.dataSource.data = [];
            this.loaderService.hide();
          }
        }
        else {
          this.paginatorTotalLength = 0;
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.loaderService.hide();
        }
      });
    }
  }

  onFilterByMyTask(type: any, txt: any) {
    this.taskListFolderID=0;
    this.taskListSelected=false;
    this.taskListID = 0;// Reset TaskId.  
    this.ShowCustomColumn = false;
    this.showAddGroupButton = false;
    this.SingleTaskArchived=false;
    this.taskListIDSharedWithMe = 0;
    this.myTaskText = txt;
    this.isMyTaskFilterSelected = true;
    this.dataSource.data = []; // Reset data .
    if (type == 1) {
      this.IsAssignedToMe = false;
      this.IsAssignedToMyRole = false;
      this.IsCreatedByMe = false;
      this.IsAllTask = true;

      this.dueDatetext = 'Due Date';
      this.preoritytext = "Priority";
      this.myTaskText = "Task";
      this.dateFrom = null;
      this.dateTo = null;
    }
    else if (type == 2) {
      this.IsAssignedToMe = false;
      this.IsAssignedToMyRole = false;
      this.IsCreatedByMe = true;
      this.IsAllTask = false;

      this.dueDatetext="This Week";

      this.dateFrom = this.GetCurrentWeekStart().utc().format('YYYY-M-D');//moment().startOf('week').utc().format('YYYY-M-D');
      this.dateTo = this.GetCurrentWeekEnd().utc().format('YYYY-M-D');;//moment().endOf('week').utc().format('YYYY-M-D');

    }
    else if (type == 3) {
      this.IsAssignedToMe = true;
      this.IsAssignedToMyRole = false;
      this.IsCreatedByMe = false;
      this.IsAllTask = false;

      this.dueDatetext="This Week";

      this.dateFrom = this.GetCurrentWeekStart().utc().format('YYYY-M-D');//moment().startOf('week').utc().format('YYYY-M-D');
      this.dateTo = this.GetCurrentWeekEnd().utc().format('YYYY-M-D');;//moment().endOf('week').utc().format('YYYY-M-D');
    }
    else if (type == 4) {
      this.IsAssignedToMe = false;
      this.IsAssignedToMyRole = true;
      this.IsCreatedByMe = false;
      this.IsAllTask = false;

      this.dueDatetext="This Week";
      this.dateFrom = this.GetCurrentWeekStart().utc().format('YYYY-M-D');//moment().startOf('week').utc().format('YYYY-M-D');
      this.dateTo = this.GetCurrentWeekEnd().utc().format('YYYY-M-D');;//moment().endOf('week').utc().format('YYYY-M-D');

    }
    this.ShowNoRecordFound = false;
    this.loaderService.show();
    this.pageSize=30;
    this.pageIndex=1;
    this.totalTask=0;
    var ReqModel = {
      "paging": {
        "pageSize":  this.pageSize,//pageData.pageSize,
        "pageIndex": this.pageIndex  //pageData.pageIndex,
      },
      "filter": {
        IsAssignedToMe: this.IsAssignedToMe,
        IsAssignedToMyRole: this.IsAssignedToMyRole,
        IsCreatedByMe: this.IsCreatedByMe,
        IsAllTask: this.IsAllTask,
        "title": this.value,
        "description": "",
        "attachedTitle": "",
        "taskListID": this.taskListID,
        TaskListFolderID: this.taskListFolderID,
        "createdOn": {
          "from": null,
          "to": null
        },
        "assignedOn": {
          "from": null,
          "to": null
        },
        "assignees": [
          0
        ],
        "Priority": this.preorityArray,
        "byDate": {
          "from": this.dateFrom,
          "to": this.dateTo
        },
        isOverDue: this.isOverDue,
        "dueDate": this.isDuedate,
        "status": this.statustype,
        "attachmentType": 0
      },
      "isArchived": false,
      taskType: 2, // 0-External, 1-Internal ,2-Both
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId     
    }
    this.taskService.getTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.dataSource = new MatTableDataSource<any>();
          // if (ReqModel.filter != null && ReqModel.filter != undefined && ReqModel.filter.taskListID == 0) {
          //   this.taskList = response.data.tasks.filter(m => m.isInternal == true);
          // }
          // else {
          //   this.taskList = response.data.tasks;
          // }
          // this.totalTask= response.data.paging.recordCount;

          // this.taskList.forEach(state => {
          //   if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
          //     state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
          //  }
          // });
          // if (response.data.tasks.length > 0) {
          //   response.data.tasks.map(state => {

          //     this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

          //     if (state.status == 0) {
          //       this.statusGroup.controls["status" + state.taskId].setValue(1);
          //     } else {
          //       this.statusGroup.controls["status" + state.taskId].setValue(state.status);
          //     }

          //     this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

          //     if (state.priority == 0) {
          //       this.statusGroup.controls["priority" + state.taskId].setValue(1);
          //     } else {
          //       this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
          //     }

          //   })
          // }

          if (response.data.tasks.length > 0) {
            response.data.tasks.map(state => {

              this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

              if (state.status == 0) {
                this.statusGroup.controls["status" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["status" + state.taskId].setValue(state.status);
              }

              this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

              if (state.priority == 0) {
                this.statusGroup.controls["priority" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
              }
            })
          }

          this.totalTask= response.data.paging.recordCount;     

          if (ReqModel.filter != null && ReqModel.filter != undefined && ReqModel.filter.taskListID == 0) {
                            
            if(this.pageIndex==1){
              //this.taskList = response.data.tasks.filter(m => m.isInternal == true);              
              this.taskList = response.data.tasks;
              if(this.taskList.length>0){
                this.taskList.forEach(state => {
                  if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
                    //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                   state.dueDate = state.dueDate+'.000Z';
                 }
                }); 
              }            
            }else{
              var data=[]
              data = response.data.tasks;//.filter(m => m.isInternal == true);
  
              if(data.length>0){
                data.forEach(state => {
                  if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
                    //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate+'.000Z';
                 }
                 this.taskList.push(state);
                }); 
              }          
            }                 
          }
          else {
            this.taskList = response.data.tasks;
          }     

          this.dataSource.data = this.taskList;
          this.dataSource.sort = this.sort;
          this.columns[0].groups = [{
            id: 0,
            title: 'Default Group',
            dragDisabled: true,
            items: this.taskList
          }];
          if (this.taskList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
        }
        else {
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }

  onFilterByPreority(type: any, txt: any) {
    this.ShowCustomColumn = false;
    this.taskListIDSharedWithMe = 0;
    this.preoritytext = txt;
    this.preorityArray = [];
    this.preorityArray.push(type);
    this.ShowNoRecordFound = false;
    this.SingleTaskArchived= false;
    this.loaderService.show();
    this.getSearchResults();
  }

  GettaskByFilter(type: any) {
    this.ShowCustomColumn = false;
    this.SingleTaskArchived=false;
    this.taskListIDSharedWithMe = 0;
    this.isOverDue = false;
    this.isDuedate = true;
    this.dueDatetext = type;
    if (type == 'Today') {
      this.dateFrom = moment().utc().format('YYYY-M-D');
      this.dateTo = moment().utc().format('YYYY-M-D');
    }
    else if (type == 'Tomorrow') {
      this.dateFrom = moment().add(1, 'day').utc().format('YYYY-M-D');
      this.dateTo = moment().add(1, 'day').utc().format('YYYY-M-D');
    }
    else if (type == 'This Week') {
      this.dateFrom = this.GetCurrentWeekStart().utc().format('YYYY-M-D');//moment().startOf('week').utc().format('YYYY-M-D');
      this.dateTo = this.GetCurrentWeekEnd().utc().format('YYYY-M-D');;//moment().endOf('week').utc().format('YYYY-M-D');
    }
    else if (type == 'Next Week') {
      this.dateFrom = this.GetNextWeekStart().utc().format('YYYY-M-D');// ;moment().add(1, 'week').startOf('week').utc().format('YYYY-M-D');
      this.dateTo = this.GetNextWeekEnd().utc().format('YYYY-M-D'); //moment().add(1, 'week').endOf('week').utc().format('YYYY-M-D');
    }
    else if (type == 'Overdue') {
      this.isOverDue = true;
      this.dateFrom = moment().utc().format('YYYY-M-D');
      this.dateTo = moment().utc().format('YYYY-M-D');
    }
    this.getSearchResults();
  }

  GetCurrentWeekStart() {
    var today = moment();
    var daystoMonday = 0 - (today.isoWeekday());
    var nextMonday = today.add(daystoMonday, 'days');

    return nextMonday;
  }

  GetCurrentWeekEnd() {
    var thisMonday = this.GetCurrentWeekStart();
    var thisSunday = thisMonday.add(6, 'days');
    return thisSunday;
  }

  GetNextWeekStart() {
    var today = moment();
    var daystoMonday = 0 - (today.isoWeekday()) + 7;
    var nextMonday = today.add(daystoMonday, 'days');

    return nextMonday;
  }

  GetNextWeekEnd() {
    var nextMonday = this.GetNextWeekStart();
    var nextSunday = nextMonday.add(6, 'days');
    return nextSunday;
  }


  GettaskByFilterStatus(type: any, txt: any) {
    this.SingleTaskArchived=false;
    this.statustype = type;
    if (this.taskListID == 0) {
      this.statustext = txt;
      this.ShowNoRecordFound = false;
      this.loaderService.show();
      var ReqModel = {
        IsFilterApply: true,
        "filter": {
          IsAssignedToMe: this.IsAssignedToMe,
          IsAssignedToMyRole: this.IsAssignedToMyRole,
          IsCreatedByMe: this.IsCreatedByMe,
          IsAllTask: this.IsAllTask,
          "title": this.value,
          "description": "",
          "attachedTitle": "",
          "taskListID": this.taskListID,
          TaskListFolderID: this.taskListFolderID,
          "createdOn": {
            "from": null,
            "to": null
          },
          "assignedOn": {
            "from": null,
            "to": null
          },
          "assignees": [
            0
          ],
          "Priority": this.preorityArray,
          "byDate": {
            "from": this.dateFrom,
            "to": this.dateTo
          },
          isOverDue: this.isOverDue,
          "dueDate": this.isDuedate,
          "status": Number(type),
          "attachmentType": 0
        },
        "isArchived": false,
        taskType: 2, // 0-External, 1-Internal ,2-Both
        userID: this.currentUser.UID,
        officeID: this.myOfficeID,
        organizationID: Number(this.organizationId),
        officeIDList: this.OfficeIDList,
        databaseID: this.databaseId
      }
      this.taskService.getTaskList(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
            this.dataSource = new MatTableDataSource<any>();
            if (ReqModel.filter != null && ReqModel.filter != undefined && ReqModel.filter.taskListID == 0) {
              //this.taskList = response.data.tasks.filter(m => m.isInternal == true);
              this.taskList = response.data.tasks;
            }
            else {
              this.taskList = response.data.tasks;
            }

            if (this.taskList.length > 0) {
              this.taskList.map(state => {
  
                this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));
  
                if (state.status == 0) {
                  this.statusGroup.controls["status" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["status" + state.taskId].setValue(state.status);
                }
  
                this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));
  
                if (state.priority == 0) {
                  this.statusGroup.controls["priority" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
                }
              })
            }

            this.taskList.forEach(state => {
              if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
                //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
               state.dueDate = state.dueDate+'.000Z';
             }
            });
            this.dataSource.data = this.taskList;
            this.dataSource.sort = this.sort;
            this.columns[0].groups = [{
              id: 0,
              title: 'Default Group',
              dragDisabled: true,
              items: this.taskList
            }];
            // this.FieldColumnToogle = response.data.gridSettings;
            // this.FieldColumn = response.data.gridSettings;

            // if( this.FieldColumn.length>0){
            //   this.FieldColumn =  this.FieldColumn.filter(x=>x.isDisplay==true);
            // }
            if (this.taskList.length > 0) {
              this.ShowNoRecordFound = false;
            } else {
              this.ShowNoRecordFound = true;
            }
          }
          else {
            this.ShowNoRecordFound = true;
            this.taskList = [];
            this.dataSource.data = [];
            this.loaderService.hide();
          }
        }
        else {
          this.paginatorTotalLength = 0;
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.loaderService.hide();
        }
      });
    }
    if (this.taskListID > 0) {
      this.statustext = txt;
      // this.preorityArray=[];
      // this.preorityArray.push(type); 
      this.ShowNoRecordFound = false;
      this.loaderService.show();
      if (this.dueDatetext == 'Today') {
        this.dateFrom = moment().utc().format('YYYY-M-D');
        this.dateTo = moment().utc().format('YYYY-M-D');
      }
      else if (this.dueDatetext == 'Tomorrow') {
        this.dateFrom = moment().add(1, 'day').utc().format('YYYY-M-D');
        this.dateTo = moment().add(1, 'day').utc().format('YYYY-M-D');
      }
      else if (this.dueDatetext == 'This Week') {
        this.dateFrom = moment().startOf('week').utc().format('YYYY-M-D');
        this.dateTo = moment().endOf('week').utc().format('YYYY-M-D');
      }
      else if (this.dueDatetext == 'Next Week') {
        this.dateFrom = moment().add(1, 'week').startOf('week').utc().format('YYYY-M-D');
        this.dateTo = moment().add(1, 'week').endOf('week').utc().format('YYYY-M-D');
      }
      else if (this.dueDatetext == 'Overdue') {
        this.isOverDue = true;
        this.dateFrom = moment().utc().format('YYYY-M-D');
        this.dateTo = moment().utc().format('YYYY-M-D');
      }
      var ReqModel1 = {
        taskListID: this.taskListID,
        //"tasktype": 0,
        moduleID: this.folderId,
        IsFilterApply: true,
        "filters": {
          Keyword: this.value,
          Priority: this.preorityArray,
          Status: this.statustype,
          isOverDue: this.isOverDue,
          "ByDate": {
            "from": this.dateFrom,
            "to": this.dateTo
          }
        },
        userID: this.currentUser.UID,
        officeID: this.myOfficeID,
        organizationID: Number(this.organizationId),
        officeIDList: this.OfficeIDList,
        databaseID: Number(this.databaseId)
      }
      this.taskService.GetTaskGroupsByTaskList(ReqModel1).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
            this.dataSource = new MatTableDataSource<any>();
            this.myTaskText = response.data.taskListName;
            this.columns = JSON.parse(JSON.stringify(this.columnsCopy));
            if (response.data.taskGroups !== undefined && response.data.taskGroups !== null) {
              response.data.taskGroups = response.data.taskGroups.sort(function (a, b) {
                return a.groupPosition - b.groupPosition;
              });

              const taskFil = response.data.taskGroups.filter(x => x.tasks.length > 0)
              taskFil.map(data => {
                data.tasks.forEach(state => {
                  this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

                  if (state.status == 0) {
                    this.statusGroup.controls["status" + state.taskId].setValue(1);
                  } else {
                    this.statusGroup.controls["status" + state.taskId].setValue(state.status);
                  }
                  this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

                  if (state.priority == 0) {
                    this.statusGroup.controls["priority" + state.taskId].setValue(1);
                  } else {
                    this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
                  }
                  if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
                   // state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate+'.000Z';
                 }
                })
              })

              response.data.taskGroups.forEach(tg => {

                if (tg.tasks !== undefined && tg.tasks !== null) {
                  tg.tasks.forEach(ts => {
                    ts.formLink = this.reSetFormURL(ts.taskId, ts.formLink);
                    if (ts.dueDate!=null && ts.dueDate!=undefined && ts.dueDate!="") {
                      ts.dueDate = moment(ts.dueDate).local().format('YYYY-MM-DD');
                   }
                  });
                  tg.tasks = tg.tasks.sort(function (a, b) {
                    return a.position - b.position;
                  });
                }
                this.columns[0].groups.push({
                  id: tg.taskGroupId,
                  title: tg.taskGroupName == "Undefined" ? 'Default Group' : tg.taskGroupName,
                  items: tg.tasks,
                  dragDisabled: tg.taskGroupName == "Undefined" ? true : false,
                  groupPosition: tg.groupPosition,
                  processStageID:tg.processStageID,
                  processStageName:tg.processStageName,
                  isTriggered:tg.isTriggered,
                  groupType:tg.groupType
                });
              });
            }
            this.taskList = response.data.getTaskDetailResponseDTOs;
            this.FieldColumnToogle = response.data.gridSettings;
            this.FieldColumn = response.data.gridSettings;

            if (this.FieldColumn.length > 0) {
              this.FieldColumn = this.FieldColumn.filter(x => x.isDisplay == true);
            }
            if (response.data.taskGroups.length > 0) {
              this.ShowNoRecordFound = false;
            } else {
              this.ShowNoRecordFound = true;
            }
          }
          else {
            this.ShowNoRecordFound = true;
            this.taskList = [];
            this.dataSource.data = [];
            this.loaderService.hide();
          }
        }
        else {
          this.paginatorTotalLength = 0;
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.loaderService.hide();
        }
      });
    }
  }



  MyTaskFunction() {
    this.ShowCustomColumn = false;
    this.showAddGroupButton = false;
    this.dueDatetext = 'Due Date';
    this.taskListFolderID = 0;
    this.taskListID = 0;
    this.taskListIDSharedWithMe = 0;
    this.isDuedate = false;
    this.isOverDue = false;
    this.dateFrom = null;
    this.dateTo = null;
    this.preoritytext = "Priority";
    this.preorityArray = [];
    this.IsAssignedToMe = false;
    this.IsAssignedToMyRole = false;
    this.IsCreatedByMe = false;
    this.IsAllTask = false;
    this.myTaskText = "Task";
    this.isMyTaskFilterSelected = false;
    this.getTaskList(undefined);
  }

showLoadingData:boolean=false;

  getTaskList(pageData: any) {
    this.ShowNoRecordFound = false;  
    if(this.pageIndex==1){
      this.loaderService.show();
      this.showLoadingData=false;
    }else{
      this.showLoadingData=true;
    }
    var isArchived=false;
    if(pageData==true){
      isArchived=true;
      this.SingleTaskArchived=true;
    }else{
      isArchived=false;
      this.SingleTaskArchived=false;
    }
    
    if (this.dueDatetext == 'This Week') {
      this.dateFrom = moment().startOf('week').utc().format('YYYY-M-D');
      this.dateTo = moment().endOf('week').utc().format('YYYY-M-D');
    }
    var ReqModel = {
      "paging": {
        "pageSize":  this.pageSize,
        "pageIndex":  this.pageIndex,
      },
      
      "filter": {
        IsAssignedToMe: this.IsAssignedToMe,
        IsAssignedToMyRole: this.IsAssignedToMyRole,
        IsCreatedByMe: this.IsCreatedByMe,
        IsAllTask: this.IsAllTask,
        "title": this.value,
        "description": "",
        "attachedTitle": "",
        "taskListID": this.taskListID,
        TaskListFolderID: this.taskListFolderID,
        "createdOn": {
          "from": null,
          "to": null
        },
        "assignedOn": {
          "from": null,
          "to": null
        },
        "assignees": [
          0
        ],
        "Priority": this.preorityArray,
        "byDate": {
          "from": this.dateFrom,
          "to": this.dateTo
        },
        isOverDue: this.isOverDue,
        "dueDate": this.isDuedate,
        "status": this.statustype,
        "attachmentType": 0
      },
      isArchived: isArchived,
      taskType: 2, // 0-External, 1-Internal ,2-Both
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId    
    }
    this.taskService.getTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        this.showLoadingData=false;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.dataSource = new MatTableDataSource<any>();
          if (response.data.tasks.length > 0) {
            response.data.tasks.map(state => {

              this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

              if (state.status == 0) {
                this.statusGroup.controls["status" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["status" + state.taskId].setValue(state.status);
              }

              this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

              if (state.priority == 0) {
                this.statusGroup.controls["priority" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
              }
            })
          }

          this.totalTask= response.data.paging.recordCount;     

          if (ReqModel.filter != null && ReqModel.filter != undefined && ReqModel.filter.taskListID == 0) {
                            
            if(this.pageIndex==1){
              //this.taskList = response.data.tasks.filter(m => m.isInternal == true);              
              this.taskList = response.data.tasks;
              if(this.taskList.length>0){
                this.taskList.forEach(state => {
                  if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
                  //  state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                   state.dueDate = state.dueDate+'.000Z';
                 }
                }); 
              }            
            }else{
              var data=[]
              data = response.data.tasks;//.filter(m => m.isInternal == true);
  
              if(data.length>0){
                data.forEach(state => {
                  if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
                  // state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                   state.dueDate = state.dueDate+'.000Z';
                 }
                 this.taskList.push(state);
                }); 
              }
             // this.taskList.push(data);
            }                 
          }
          else {
            this.taskList = response.data.tasks;
          }      
               
          this.dataSource.data = this.taskList;

          this.dataSource.sort = this.sort;

         // let allAssigne: any;

       //   this.taskList.taskAssignedEntity?.map(item => {
       //    allAssigne.push(item.assigneeName)
       //  })
       //  this.taskList.taskAssignedEntity[0].assigneeName = allAssigne.toString();

          this.columns[0].groups = [{
            id: 0,
            title: 'Default Group',
            dragDisabled: true,
            items: this.taskList
          }];
                 
          if (this.taskList.length > 0) {
            this.ShowNoRecordFound = false;          
          } else {
            this.ShowNoRecordFound = true;
          }
          this.showLoadingData=false;
        }
        
        else {
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }


  getStatusName(statusId) {
    var checkstatus: any = [];
    checkstatus = this.taskStatusList.filter(x => x.taskStatusID == statusId);
    if (checkstatus.length > 0) {
      return checkstatus[0].taskStatusName;
    } else {
      //var Na="NA";
      return "NA";
    }
  }

  deleteTask(task) {
    const message = `Are you sure you want to delete this task?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var taskId = 0;
          if (task.taskId == undefined) {
            taskId = task.taskID;
          } else {
            taskId = task.taskId;
          }
          var reqModel = {
            taskIds: [taskId],
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.taskService.removeTasks(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                if(this.taskListIDSharedWithMe>0){
                  this.getTaskByTaskListSharedWithMe();                  
                }
                if(this.taskListIDSharedWithMe==0){
                  if (this.taskListID == 0) {
                    this.getTaskList(this.pageModelData);
                  } else {
                    this.getTaskByTaskList();
                  }  
                } 
                // if (this.taskListID == 0) {
                //   this.getTaskList(this.pageModelData);
                // } else {
                //   this.getTaskByTaskList();
                // }
                this.loaderService.hide();
                this.toastr.success('Task deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
                this.toastr.error('Task deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  ArchiveTask(task) {
    this.taskListSelectedArchived=true;
    this.taskListsArchived=[];
    const message = `Are you sure you want to archive this task?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var taskId = 0;
          if (task.taskId == undefined) {
            taskId = task.taskID;
          } else {
            taskId = task.taskId;
          }
          var reqModel = {
            taskIds: [taskId],
            isArchived: true,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.taskService.archivedTask(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {

                if(this.taskListIDSharedWithMe>0){
                  this.getTaskByTaskListSharedWithMe();                  
                }
                if(this.taskListIDSharedWithMe==0){
                  if (this.taskListID == 0) {
                     this.pageIndex=1;
                     this.pageSize=30;
                    this.getTaskList(this.pageModelData);
                  } else {
                    this.getTaskByTaskList();
                  }  
                } 

                // if (this.taskListID == 0) {
                //   this.pageIndex=1;
                //   this.pageSize=30;
                //   this.getTaskList(this.pageModelData);
                // } else {
                //   this.getTaskByTaskList();
                // }


                //this.getSingleTaskList();
                this.loaderService.hide();
                this.toastr.success('Task archived successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
                this.toastr.error('Task archived failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task archived failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  UnArchiveTask(task) {
    this.taskListSelectedArchived=true;
    this.taskListsArchived=[];
    const message = `Are you sure you want to Unarchive this task?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var taskId = 0;
          if (task.taskId == undefined) {
            taskId = task.taskID;
          } else {
            taskId = task.taskId;
          }
          var reqModel = {
            taskIds: [taskId],
            isArchived: false,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.taskService.archivedTask(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                if (this.taskListID == 0) {
                  this.pageIndex=1;
                  this.pageSize=30;
                  this.getTaskList(true);
                } else {
                  this.getTaskByTaskList();
                }     
                this.loaderService.hide();
                this.toastr.success('Task Unarchived successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
                this.toastr.error('Task Unarchived failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task Unarchived failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  deleteMultipleTask() {
    const message = `Are you sure you want to delete selected task?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var selectedtasklist = [];
          if (this.selectedRecordMoveToArray.length > 0) {
            for (var i = 0, len = this.selectedRecordMoveToArray.length; i < len; ++i) {
              const taskid = this.selectedRecordMoveToArray[i].selectedRecord;
              selectedtasklist.push(taskid);
            }
          }
          var reqModel = {
            taskIds: selectedtasklist,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.taskService.removeTasks(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.showMoveToOption = false;
                this.selectedRecordMoveToArray = [];
                this.selection.clear();
                this.loaderService.hide();
                this.toastr.success('Task deleted successfully.', '', {
                  timeOut: 3000,
                });
                if(this.taskListIDSharedWithMe>0){
                  this.getTaskByTaskListSharedWithMe();                  
                }
                if(this.taskListIDSharedWithMe==0){
                  if (this.taskListID == 0) {
                    this.getTaskList(this.pageModelData);
                  } else {
                    this.getTaskByTaskList();
                  }  
                }                            
              } else {
                this.showMoveToOption = false;
                this.selectedRecordMoveToArray = [];
                this.selection.clear();
                this.loaderService.hide();
                this.toastr.error('Task deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.showMoveToOption = false;
              this.selectedRecordMoveToArray = [];
              this.selection.clear();
              this.loaderService.hide();
              this.toastr.error('Task deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  showMyDrive() {
    this.showmyDrive = !this.showmyDrive
  }


  taskListIdForAdd:number=0;

  createNewTask() {
    this.taskListIdForAdd=0;
    if(this.taskListIDSharedWithMe>0){
      this.taskListIdForAdd=this.taskListIDSharedWithMe;
    }
    if(this.taskListID>0){
      this.taskListIdForAdd=this.taskListID;
    }
    this.taskId = 0;
    this.showCreateTask = true;
  }

  closeCreateTask(messages: boolean) {
    this.showCreateTask = messages;
  }


  getCloseCreateTask() {
    this.showCreateTask = false;
  }

  getSaveTask() {
    if(this.taskListIDSharedWithMe>0){
      this.getTaskByTaskListSharedWithMe();
      return;
    }    
    if (this.taskListID == 0) {
      this.getTaskList(this.pageModelData);
    }
    if (this.taskListID > 0) {
      this.getTaskByTaskList();
    }
  }

  getTaskDetail(task: any) {
    if (task.taskId == undefined) {
      this.taskId = task.taskID;
    } else {
      this.taskId = task.taskId;
    }
    this._dataSharingService.sendRefreshListAfterAddingParticipant("");  
    this.showTaskDetail = true;
  }

  closeTaskDetail(messages: boolean) {
    this.showTaskDetail = messages;
  }

  closeSaveTaskDetail(messages: boolean) {
    this.showTaskDetail = messages;
    if(this.taskListIDSharedWithMe>0){
      this.getTaskByTaskListSharedWithMe();                  
    }
    if(this.taskListIDSharedWithMe==0){
      if (this.taskListID == 0) {
        this.getTaskList(this.pageModelData);
      } else {
        this.getTaskByTaskList();
      }  
    } 
    // if (this.taskListID == 0) {
    //   this.getTaskList(this.pageModelData);
    // }
    // if (this.taskListID > 0) {
    //   this.getTaskByTaskList();
    // }
  }

  showPIntelligence(messages: boolean) {
    this.showProcess = messages;
  }

  closePIntelligence(messages: boolean) {
    this.showProcess = messages;
  }

  showSubtask() {
    this.showSub = !this.showSub;
  }

  showSubtask1() {
    this.showSub1 = !this.showSub1;
  }

  // tasks = [
  //   {
  //     taskname :'Patient Registration',
  //     department:'Doctor',
  //     priority:'High',
  //     estimate:'2 days',
  //     type:'To Do',
  //     assigned : 'Matt mcalpin',
  //     status: 'Done',
  //     duedate: '12 Nov, 07:00 AM'
  //   },
  //   {
  //     taskname :'Patient Checkup',
  //     department:'Nursing',
  //     priority:'Low',
  //     estimate:'2 days',
  //     type:'Document',
  //     assigned : 'Matt mcalpin',
  //     status: 'Done',
  //     duedate: '15 Nov, 08:00 AM'
  //   },
  //   {
  //     taskname :'Patient Surgery',
  //     department:'Admin',
  //     priority:'Low',
  //     estimate:'2 days',
  //     type:'Appointment',
  //     assigned : 'Matt mcalpin',
  //     status: 'Working',
  //     duedate: '18 Nov, 09:00 AM'
  //   },
  //   {
  //     taskname :'Patient Monitiring',
  //     department:'Staff Boy',
  //     priority:'Medium',
  //     estimate:'2 days',
  //     type:'Phone Call',
  //     assigned : 'Matt mcalpin',
  //     status: 'Working',
  //     duedate: '20 Nov, 10:00 AM'
  //   },
  //   {
  //     taskname :'Patient Discharge',
  //     department:'Doctor',
  //     priority:'High',
  //     estimate:'2 days',
  //     type:'Email',
  //     assigned : 'Matt mcalpin',
  //     status: 'Not Started',
  //     duedate: '-'
  //   }
  // ];

  // drop(event: CdkDragDrop<string[]>) {
  //   moveItemInArray(this.tasks, event.previousIndex, event.currentIndex);
  // }

  closeTemplate() {
    this.showAddTemp=false;
    this.taskListFolderID = 0;
    this.selectedTaskCategoryID = 0;
    this.searchTemplateName = "";
    this.categoryType=0;
    this.addtaskTemplateName="";
    this.dialog.closeAll();
  }

  close() {
    this.taslTemplateID = 0;
    this.myfolderForm.reset();
    this.taskListFolderID = 0;
    // this.taskListID=0;
    this.dialog.closeAll();
  }



  closeSaveAsTemplate() {
    this.taslTemplateID = 0;
    this.addTemplateForm.reset();
    this.taskListFolderID = 0;
    // this.taskListID=0;
    this.dialog.closeAll();
  }
  

  assignUser(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'selectParticipants',
    });
  }

  renameFile(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef);
  }

  taskComplete: boolean = false;

  markComplete(task: any) {
    if (task.status !== this.completedTaskStatusID)
      this.completeTask(task);
  }

  selectedTaskOption: any
  showAssignedTask = false;
  showReminderTask = false;
  showScheduleTask = false;
  showAttachTask = false;

  addTaskOption(val: string, task: any) {

    this.taskId = task.taskId;

    if (val === 'Assigned') {
      this.showAssignedTask = true;

      this.showReminderTask = false;
      this.showScheduleTask = false;
      this.showAttachTask = false;
    }
    if (val === 'Reminder') {
      this.showReminderTask = true;

      this.showAssignedTask = false;
      this.showScheduleTask = false;
      this.showAttachTask = false;
    }
    if (val === 'Schedule') {
      this.showScheduleTask = true;

      this.showAssignedTask = false;
      this.showReminderTask = false;
      this.showAttachTask = false;
    }
    if (val === 'Attach') {
      this.showAttachTask = true;

      this.showAssignedTask = false;
      this.showReminderTask = false;
      this.showScheduleTask = false;
    }

  }

  addSubTaskOption(task: any) {
    this.taskId = task.taskId;
    this.showCreateTask = true;
  }

  closeTask(val: boolean) {
    this.showAssignedTask = val
  }

  closeReminder(val: boolean) {
    this.showReminderTask = val
  }

  closeSchedule(val: boolean) {
    this.showScheduleTask = val
  }

  closeAttach(val: boolean) {
    this.showAttachTask = val
  }


  templateGallery(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }




  //================For Left Side Panel  TaskFolder ========================//


  folderortask: string = "";
  folderTaskName: string = "";

  myfolderForm: FormGroup;
  addTemplateForm: FormGroup;
  spinner: boolean = false;
  taskListFolderID: number = 0;
  taskListID: number = 0;
  taskListIDSharedWithMe: number = 0;
  taskLists: any = [] = [];
  taskListsSharedWithMe: any = [] = [];
  expandedIndex: number = 0;
  expandedIndexSharedWithMe: number = 0;
  expandedIndexmoveTo: number = 0;

  getTaskListFolders() {
    this.loaderService.show();
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskListFolders(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskListFolder = response.data.taskListFolders;
          
          // if(this.receivedLinkData!=undefined){
          //    if(this.receivedLinkData.isSharedTasklist==false){
          //     var CheckRecord=[];
          //     CheckRecord = response.data.taskListFolders.filter(x=>x.taskListFolderID==this.receivedLinkData.folderID);
          //     if(CheckRecord.length>0){
          //      const index = response.data.taskListFolders.findIndex(x => x.taskListFolderID === this.receivedLinkData.folderID);
          //      this.receivedLinkData.taskListFolderID=this.receivedLinkData.folderID;
          //      this.getTaskLists(this.receivedLinkData,index);
          //     }
          //   }           
          // }
        }
        else {
          this.taskListFolder = [];
          this.loaderService.hide();
        }
      }
      else {
        this.taskListFolder = [];
        this.loaderService.hide();
      }
    });
  }

  completeTask(task) {   
    this.loaderService.show();
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      TaskID: task.taskId,
      status: this.completedTaskStatusID,
      databaseID: this.databaseId
    }
    this.taskService.UpdateTaskStatus(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          task.status = this.completedTaskStatusID;
          this.toastr.success("Completed successfully.");

          if(this.taskListIDSharedWithMe>0){
            this.getTaskByTaskListSharedWithMe();
          }else{
            this.getTaskByTaskList();
          }  
          //this.getTaskByTaskList();
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  addFolder(templateRef: TemplateRef<any>, folderortask: any, tasklist: any) {
    this.taskListFolderID = 0;
    this.showAddGroupButton = false;
    this.taskListID = 0;
    this.taskListIDSharedWithMe = 0;
    this.taslTemplateID = 0;
    let group = {};
    this.myfolderForm = new FormGroup(group);
    this.createTaskFolder();
    this.folderortask = folderortask;
    if (this.folderortask.toLowerCase() == "folder") {
      this.folderTaskName = "Folder";
    } else {
      this.folderTaskName = "Task List";
      this.getTaskTemplates();
    }
    if (tasklist != "") {
      this.taskListFolderID = tasklist.taskListFolderID;
    }
    this.dialog.open(templateRef);
  }


  addTaskListButton: boolean = false;
  TaskListName: string = "";
  taskCategoryList: any[] = [];
  filteredTaskCategoryList: any[] = [];
  selectedTaskCategoryID: number = 0;

  addTaskListTemp(templateRef: TemplateRef<any>, tasklist: any, index: number) {
    this.addTaskListButton = false;
    this.TaskListName = "";
    this.searchTemplateName = "";

    this.expandedIndex = index;

    this.taskListFolderID = 0;
    this.taskListID = 0;
    this.taskListIDSharedWithMe = 0;
    this.showAddGroupButton = false;
    this.taslTemplateID = 0;

    this.selectedTaskCategoryID = 0;

    this.getTaskTemplates();

    this.taskListFolderID = tasklist.taskListFolderID;

    this.getActiveTaskTemplateCategories();

    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }


  addRoleTemp(templateRef: TemplateRef<any>, tasklist: any, index: number) {
    this.sharedAccessRoleList = [];
    this.selectedsharedAccessRole = [];
    this.showAddButton = false;
    this.addTaskListButton = false;
    this.TaskListName = "";
    this.searchTemplateName = "";

    this.expandedIndex = index;

    this.taskListFolderID = 0;
    this.taskListID = 0;
    this.taskListIDSharedWithMe = 0;
    this.showAddGroupButton = false;
    this.taslTemplateID = 0;

    this.selectedTaskCategoryID = 0;

    this.getTaskTemplates();

    this.taskListFolderID = tasklist.taskListFolderID;

    this.getActiveTaskTemplateCategories();
    this.GetTasklistFolderSharedRoles(tasklist.taskListFolderID)

    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  addRoleTempSharedWithMe(templateRef: TemplateRef<any>, tasklist: any, index: number) {
    this.sharedAccessRoleList = [];
    this.selectedsharedAccessRole = [];
    this.showAddButton = false;
    this.addTaskListButton = false;
    this.TaskListName = "";
    this.searchTemplateName = "";

    this.expandedIndex = index;

    this.taskListFolderID = 0;
    this.taskListID = 0;
    this.taskListIDSharedWithMe = 0;
    this.showAddGroupButton = false;
    this.taslTemplateID = 0;

    this.selectedTaskCategoryID = 0;   

    //this.taskListFolderID = tasklist.id;   
    this.GetTasklistFolderSharedRoles(tasklist.id)

    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  // getActiveTaskTemplateCategories() {
  //   var ReqModel = {
  //     userID: this.currentUser.UID,
  //     organizationID: Number(this.organizationId),
  //     officeID: this.myOfficeID,
  //     officeIDList: this.OfficeIDList,
  //     databaseID: Number(this.databaseId),
  //     type:this.categoryType>0?this.categoryType:0
  //   }
  //   this.taskService.getActiveTaskTemplateCategories(ReqModel).subscribe(response => {
  //     if (response != undefined) {
  //       this.responseHolder = response;
  //       this.loaderService.hide();
  //       if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
  //         this.taskCategoryList = response.data;
  //         this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == this.categoryType);
  //       }
  //       else {
  //         this.taskCategoryList = [];
  //         this.filteredTaskCategoryList = [];
  //       }
  //     }
  //     else {
  //       this.taskCategoryList = [];
  //       this.filteredTaskCategoryList = [];
  //     }
  //   });
  // }


  getActiveTaskTemplateCategories1() {   
    this.loaderService.show();
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      type: this.categoryType > 0 ? this.categoryType : 0
    };
    this.taskService.getActiveTaskTemplateCategories(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskCategoryList = response.data;
          this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == this.categoryType);
        } else {
          this.taskCategoryList = [];
          this.filteredTaskCategoryList = [];
        }
      } else {
        this.taskCategoryList = [];
        this.filteredTaskCategoryList = [];
      }
    });
  }

  getActiveTaskTemplateCategories(): Observable<any> { // Return type added
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      type: this.categoryType > 0 ? this.categoryType : 0
    };
    return this.taskService.getActiveTaskTemplateCategories(ReqModel).pipe(
      tap(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
            this.taskCategoryList = response.data;
            this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == this.categoryType);
          } else {
            this.taskCategoryList = [];
            this.filteredTaskCategoryList = [];
          }
        } else {
          this.taskCategoryList = [];
          this.filteredTaskCategoryList = [];
        }
      })
    );
  }
  
  onTaskListNameChange(searchValue: string): void {
    if (searchValue.trim() == "") {
      this.addTaskListButton = false;
    } else {
      this.TaskListName = searchValue.trim();
      this.addTaskListButton = true;
    }
  }


  SelectTemplateForAddTaskList(temp: any) {

    this.taslTemplateID = temp.taskTemplateID;
    this.updateTaskTemplateTasksButton = true;
  }

  currentIndex: number = 0;

  getSelectTaskCategory(e: any) {
   this.selectedTaskCategoryID = e.value;
   this.categoryTypeForSingleTask = e.value;
    this.getTaskTemplates();
  }


  getTaskListThroughCategory(e: any, i: any) {
    this.currentIndex = i
    this.selectedTaskCategoryID = e;
    this.getTaskTemplates();
  }


  async addTaskLists() {
    this.loaderService.show();
    var ReqModel = {
      taskListID: 0,
      taskListName: this.TaskListName,
      position: 0,
      folderID: this.taskListFolderID,
      taskTemplateID: this.taslTemplateID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      templateCreatedUserID: this.currentUser.UID,
      templateCreatedOrganizationID: Number(this.organizationId),
      templateCreatedOfficeID: this.myOfficeID,
    }
    // return;
    this.spinner = true;
    this.addTaskListButton = false;
    const result = await this.taskService.addTaskList(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
      this.getTaskListFolders();
      var obj = {
        taskListFolderID: this.taskListFolderID
      }
      this.getTaskLists(obj, this.expandedIndex);
      this.taslTemplateID = 0;
      this.toastr.success("Task list created successfully.", '', {
        timeOut: 3000,
      });
      this.closeTemplate();
    }
    else {
      this.toastr.error("Task list creation failed.", '', {
        timeOut: 3000,
      });
      this.spinner = false;
      this.loaderService.hide();
    }
  }



  updateFolder(templateRef: TemplateRef<any>, folderortask: any, tasklist: any) {
    this.taskListFolderID = 0;
    this.taskListID = 0;
    this.taskListIDSharedWithMe = 0;
    this.showAddGroupButton = false;
    let group = {};
    this.myfolderForm = new FormGroup(group);
    this.createTaskFolder();
    this.folderortask = folderortask;
    if (this.folderortask.toLowerCase() == "folder") {
      this.folderTaskName = "Folder";
      this.taskListFolderID = tasklist.taskListFolderID;
      this.myfolderForm.controls['folderName'].setValue(tasklist.taskListFolderName);
    } else {
      this.folderTaskName = "Task List";
      this.taskListID = tasklist.taskListID;
      this.myfolderForm.controls['folderName'].setValue(tasklist.taskListName);
    }
    this.dialog.open(templateRef);
  }

  taskListFolderIDForUpdate: number = 0;

  updateTaskLists(templateRef: TemplateRef<any>, folderortask: any, tasklist: any, tasklistfolder: any, index: number) {
    this.taskListFolderID = 0;
    this.taskListID = 0;
    this.taskListIDSharedWithMe = 0;
    this.showAddGroupButton = false;
    this.taskListFolderIDForUpdate = tasklistfolder.taskListFolderID;

    this.expandedIndex = index;

    let group = {};
    this.myfolderForm = new FormGroup(group);
    this.createTaskFolder();
    this.folderortask = folderortask;
    if (this.folderortask.toLowerCase() == "folder") {
      this.folderTaskName = "Folder";
      this.taskListFolderID = tasklist.taskListFolderID;
      this.myfolderForm.controls['folderName'].setValue(tasklist.taskListFolderName);
    } else {
      this.folderTaskName = "Task List";
      this.taskListID = tasklist.taskListID;
      this.myfolderForm.controls['folderName'].setValue(tasklist.taskListName);
    }
    this.dialog.open(templateRef);
  }

  updateTaskListsSharedWithMe(templateRef: TemplateRef<any>, folderortask: any, tasklist: any, tasklistfolder: any, index: number) {
    this.taskListFolderID = 0;
    this.taskListID = 0;
    this.taskListIDSharedWithMe = 0;
    this.showAddGroupButton = false;
    this.taskListFolderIDForUpdate = tasklistfolder.id;

    this.expandedIndex = index;

    let group = {};
    this.myfolderForm = new FormGroup(group);
    this.createTaskFolder();
    this.folderortask = folderortask;
    if (this.folderortask.toLowerCase() == "folder") {
      this.folderTaskName = "Folder";
      this.taskListFolderID = tasklist.taskListFolderID;
      this.myfolderForm.controls['folderName'].setValue(tasklist.taskListFolderName);
    } else {
      this.folderTaskName = "Task List";
      this.taskListIDSharedWithMe = tasklist.taskListID;
      this.myfolderForm.controls['folderName'].setValue(tasklist.taskListName);
    }
    this.dialog.open(templateRef);
  }

  createTaskFolder(): void {
    this.myfolderForm = this.formBuilder.group({
      folderName: ['', [Validators.required]]
    },);
  }

  createSaveAsTaskTemplate(): void {
    this.addTemplateForm = this.formBuilder.group({
      taskTemplateName: ['', [Validators.required]],
      folderID: ['', [Validators.required]],
    },);
  }

  async addTaskListFolder(data) {
    if (this.taskListFolderID == 0) {
      this.addtaskListFolders(data);
    }
    // if(this.taskListFolderID>0){
    //   this.addTaskList(data);
    //  }
  }

  taslTemplateID: number = 0;


  OnSelectTempChange(taslTemplateID) {
    this.taslTemplateID = taslTemplateID.value;
  }

  async addtaskListFolders(data) {
    this.loaderService.show();
    var ReqModel = {
      folderName: data.folderName,
      colourCode: 0,
      position: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    // return; 
    this.spinner = true;
    this.myfolderForm.markAsPristine();
    const result = await this.taskService.addTasklistFolder(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
      this.taskLists = [];
      this.getTaskListFolders();
      this.toastr.success("Task folder created successfully.", '', {
        timeOut: 3000,
      });
      this.close();
    }
    else {
      this.toastr.error("Task folder creation failed.", '', {
        timeOut: 3000,
      });
      this.spinner = false;
      this.loaderService.hide();
    }
  }

  // async addTaskList(data){
  //   this.loaderService.show();
  //   var ReqModel={     
  //     taskListID:0,
  //     taskListName: data.folderName,  
  //     position:0,
  //     folderID: this.taskListFolderID,
  //     taskTemplateID:this.taslTemplateID,
  //     userID: this.currentUser.UID,
  //     organizationID: Number(this.organizationId),
  //     databaseID: Number(this.databaseId),      
  //     officeID: this.myOfficeID,
  //     officeIDList: this.OfficeIDList
  //   } 
  //   this.spinner=true;  
  //   this.myfolderForm.markAsPristine();
  //   const result = await this.taskService.addTaskList(ReqModel).toPromise();
  //   if (result.status === this.statusConst.statusSuccess) {
  //     this.spinner=false;     
  //     this.loaderService.hide();
  //     this.getTaskListFolders();
  //     var obj={
  //       taskListFolderID:this.taskListFolderID
  //     }
  //     this.getTaskLists(obj,this.expandedIndex);
  //     this.taslTemplateID=0;
  //     this.toastr.success("Task list created successfully.", '', {
  //       timeOut: 3000,
  //     });
  //     this.close();
  //   }
  //   else {
  //     this.toastr.error("Task list create failed.", '', {
  //       timeOut: 3000,
  //     });
  //     this.spinner=false;
  //     this.loaderService.hide(); 
  //   } 
  // }
  currentTaskList: number = 0;
  currentTaskListMoveTo: number = 0;
  currentTaskListSharedWithMe: number = 0;

  taskListSelected = false;
  taskListSelectedMoveTo= false;
  taskListSelectedSharedWithMe = false;
  selectedTaskLists:any;

  getTaskLists(tasklist: any, index: number) {
    if (this.currentTaskList == index) {
      this.taskListSelected = !this.taskListSelected;
    } else {
      this.taskListSelected = true;
    }

    this.selectedTaskLists=tasklist;

    this.currentTaskList = index;

    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    // this.taskListID=0;
    this.showMoveToOption = false;
    this.SingleTaskArchived=false;
    // this.getTaskList(this.pageModelData);
    this.taskLists = [];
    this.expandedIndex = index;
    //this.loaderService.show();
    this.dueDatetext = 'Due Date';
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.taskListFolderID = tasklist.taskListFolderID;
    var ReqModel = {
      folderID: tasklist.taskListFolderID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskLists(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskLists = response.data.taskLists;
          //  this.ShowNoRecordFound=true;
          // this.taskList=[];   
          //this.dataSource.data=[];
          this.loaderService.hide();
          // if(this.taskLists.length>0){

          // } else{
          // this.ShowNoRecordFound=true;
          // this.taskList=[];   
          // this.dataSource.data=[];
          // this.loaderService.hide();
          // }     
        }
        else {
          this.taskLists = [];
          this.loaderService.hide();
        }
      }
      else {
        this.taskLists = [];
        this.loaderService.hide();
      }
    });
  }


  getTaskLists1(tasklist: any, index: number) {
    if (this.currentTaskList == index) {
      this.taskListSelected = !this.taskListSelected;
    } else {
      this.taskListSelected = true;
    }

    this.currentTaskList = index;

    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    //this.taskListID=0;
    this.showMoveToOption = false;
    this.SingleTaskArchived=false;
    // this.getTaskList(this.pageModelData);
    // this.taskLists=[];
    this.expandedIndex = index;
    // this.loaderService.show();
    this.dueDatetext = 'Due Date';
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.taskListFolderID = tasklist.taskListFolderID;
    // var ReqModel={
    //    folderID:tasklist.taskListFolderID,
    //    userID: this.currentUser.UID,
    //    officeID: this.myOfficeID,    
    //    organizationID: Number(this.organizationId),
    //    officeIDList: this.OfficeIDList,
    //    databaseID:this.databaseId
    // }      
    // this.taskService.getTaskLists(ReqModel).subscribe(response => {
    //   if (response != undefined) {
    //     this.responseHolder = response;
    //     this.loaderService.hide();
    //     if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
    //       this.taskLists = response.data.taskLists;
    //       this.ShowNoRecordFound=true;
    //       this.taskList=[];   
    //       this.dataSource.data=[];
    //       this.loaderService.hide();
    //       // if(this.taskLists.length>0){

    //       // } else{
    //       // this.ShowNoRecordFound=true;
    //       // this.taskList=[];   
    //       // this.dataSource.data=[];
    //       // this.loaderService.hide();
    //       // }     
    //     }
    //     else {
    //       this.taskLists=[];
    //       this.loaderService.hide();
    //     }
    //   }
    //   else { 
    //     this.taskLists=[];
    //     this.loaderService.hide();
    //   }
    // });
  }


  getTaskListsSharedWithMe(tasklist: any, index: number) {

    if (this.currentTaskListSharedWithMe == index) {
      this.taskListSelectedSharedWithMe = !this.taskListSelectedSharedWithMe;
    } else {
      this.taskListSelectedSharedWithMe = true;
    }

    this.currentTaskListSharedWithMe = index;
    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    this.showMoveToOption = false;
    this.SingleTaskArchived=false;
    this.taskListsSharedWithMe = [];
    this.expandedIndexSharedWithMe = index;
    this.dueDatetext = 'Due Date';
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.taskListFolderID = tasklist.id;
    var ReqModel = {
      folderID: tasklist.id,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskLists(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskListsSharedWithMe = response.data.taskLists;
          this.loaderService.hide();
        }
        else {
          this.taskListsSharedWithMe = [];
          this.loaderService.hide();
        }
      }
      else {
        this.taskListsSharedWithMe = [];
        this.loaderService.hide();
      }
    });
  }


  getTaskLists1SharedWithMe(tasklist: any, index: number) {

    if (this.currentTaskListSharedWithMe == index) {
      this.taskListSelectedSharedWithMe = !this.taskListSelectedSharedWithMe;
    } else {
      this.taskListSelectedSharedWithMe = true;
    }

    this.currentTaskListSharedWithMe = index;
    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    this.showMoveToOption = false;
    this.SingleTaskArchived=false;
    this.expandedIndexSharedWithMe = index;
    this.dueDatetext = 'Due Date';
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.taskListFolderID = tasklist.id;
  }

  //== For Delete Task List Folder ====//
  deleteTasklistFolder(tasklistfolder) {
    const message = `Are you sure you want to delete this task list folder?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            taskListFolderID: tasklistfolder.taskListFolderID,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.taskService.removeTasklistFolder(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.taskLists = [];
                this.getTaskListFolders();
                this.loaderService.hide();
                this.toastr.success('Task list folder deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
                this.toastr.error('Task list folder deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task list folder deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  //== For Delete Task List ====//
  deleteTasklist(tasklist: any, tasklistfolder: any, index: number) {
    const message = `Are you sure you want to delete this task list?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            taskListID: tasklist.taskListID,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.expandedIndex = index;
          this.loaderService.show();
          this.taskService.removeTasklist(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.taskLists = [];
                this.getTaskListFolders();
                this.loaderService.hide();
                this.toastr.success('Task list deleted successfully.', '', {
                  timeOut: 3000,
                });
                var obj = {
                  taskListFolderID: tasklistfolder.taskListFolderID
                }
                this.taskListSelected=false;
                this.getTaskLists(obj, this.expandedIndex);
              } else {
                this.loaderService.hide();
                this.toastr.error('Task list deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task list deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


   //== For Delete Task List Shared with me ====//
   deleteTasklistSharedWithMe(tasklist: any, tasklistfolder: any, index: number) {
    const message = `Are you sure you want to delete this task list?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            taskListID: Number(tasklist.taskListID),
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.expandedIndex = index;
          this.loaderService.show();
          this.taskService.removeTasklist(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.taskListsSharedWithMe = [];
                this.GetTasklistFolderSharedWithMe();
                this.loaderService.hide();
                this.toastr.success('Task list deleted successfully.', '', {
                  timeOut: 3000,
                });
                var obj = {
                  id: tasklistfolder.id
                }
                this.taskListSelectedSharedWithMe=false;
                this.getTaskListsSharedWithMe(obj, this.expandedIndex);
              } else {
                this.loaderService.hide();
                this.toastr.error('Task list deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task list deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }
  
  //== For Archive Task List ====//
  archivedTaskList(tasklist: any, tasklistfolder: any, index: number) {
    this.taskListSelectedArchived=true;
    this.taskListsArchived=[];
    const message = `Are you sure you want to archive this task list?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            taskListID: tasklist.taskListID,
            isArchived:true,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.expandedIndex = index;
          this.loaderService.show();
          this.taskService.archivedTaskList(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.taskLists = [];
                this.getTaskListFolders();
                this.loaderService.hide();
                this.toastr.success('Task list Archived successfully.', '', {
                  timeOut: 3000,
                });
                var obj = {
                  taskListFolderID: tasklistfolder.taskListFolderID
                }
                this.taskListSelected=false;
                this.getTaskLists(obj, this.expandedIndex);               
              } else {
                this.loaderService.hide();
                this.toastr.error('Task list Archived failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task list Archived failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

   //== For Archive Task List shared with me====//
   archivedTaskListSharedWithMe(tasklist: any, tasklistfolder: any, index: number) {
    this.taskListSelectedArchived=true;
    this.taskListsArchived=[];
    const message = `Are you sure you want to archive this task list?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            taskListID: Number(tasklist.taskListID),
            isArchived:true,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.expandedIndex = index;
          this.loaderService.show();
          this.taskService.archivedTaskList(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.taskListsSharedWithMe = [];
                this.GetTasklistFolderSharedWithMe();
                this.loaderService.hide();
                this.toastr.success('Task list Archived successfully.', '', {
                  timeOut: 3000,
                });
                var obj = {
                  id: tasklistfolder.id
                }
                this.taskListSelectedSharedWithMe=false;
                this.getTaskListsSharedWithMe(obj, this.expandedIndex);           
              } else {
                this.loaderService.hide();
                this.toastr.error('Task list Archived failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task list Archived failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

   //== For Archive Task List ====//
   UnarchivedTaskList(tasklist: any, tasklistfolder: any, index: number) {
    this.taskListSelectedArchived=true;
    this.taskListsArchived=[];
    const message = `Are you sure you want to unarchive this task list?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            taskListID: tasklist.taskListID,
            isArchived:false,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.expandedIndex = index;
          this.loaderService.show();
          this.taskService.archivedTaskList(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.taskLists = [];
                this.getTaskListFolders();
                this.loaderService.hide();
                this.toastr.success('Task list Unarchived successfully.', '', {
                  timeOut: 3000,
                });
                var obj = {
                  taskListFolderID: tasklistfolder.taskListFolderID
                }
                this.getTaskLists(obj, this.expandedIndex);
                this.getArchivedTaskLists();
              } else {
                this.loaderService.hide();
                this.toastr.error('Task list Unarchived failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task list Unarchived failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  // Update  Task List folder //
  async UpdateTaskListFolder(data) {
    if (this.taskListFolderID > 0) {
      // this.expandedIndex=0;
      this.updatetaskListFolders(data);
    }
    if (this.taskListID > 0) {
      this.updateTaskList(data);
    }
    if (this.taskListIDSharedWithMe > 0) {
      this.updateTaskListSharedWithMe(data);
    }
  }

  //== For rename Task List folder ====//
  async updatetaskListFolders(data) {
    this.loaderService.show();
    var ReqModel = {
      taskListFolderID: this.taskListFolderID,
      taskListFolderName: data.folderName,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    // return; 
    this.spinner = true;
    this.myfolderForm.markAsPristine();
    const result = await this.taskService.renameTasklistFolder(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
      this.getTaskListFolders();
      this.toastr.success("Task folder update successfully.", '', {
        timeOut: 3000,
      });
      this.close();
    }
    else {
      this.toastr.error("Task folder update failed.", '', {
        timeOut: 3000,
      });
      this.spinner = false;
      this.loaderService.hide();
    }
  }

  //== For rename Task List ====//
  async updateTaskList(data) {
    this.loaderService.show();
    var ReqModel = {
      taskListName: data.folderName,
      taskListID: this.taskListID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    // return;
    this.spinner = true;
    this.myfolderForm.markAsPristine();
    const result = await this.taskService.renameTasklist(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
      this.taskLists = [];
      this.getTaskListFolders();
      var obj = {
        taskListFolderID: this.taskListFolderIDForUpdate
      }
      this.taskListSelected=false;
      this.getTaskLists(obj, this.expandedIndex);
      this.toastr.success("Task list update successfully.", '', {
        timeOut: 3000,
      });
      this.close();
    }
    else {
      this.toastr.error("Task list update failed.", '', {
        timeOut: 3000,
      });
      this.spinner = false;
      this.loaderService.hide();
    }
  }

//== For rename Task List For Shared with Me ====//
async updateTaskListSharedWithMe(data) {
  this.loaderService.show();
  var ReqModel = {
    taskListName: data.folderName,
    taskListID: Number(this.taskListIDSharedWithMe),
    userID: this.currentUser.UID,
    organizationID: Number(this.organizationId),
    databaseID: Number(this.databaseId),
    officeID: this.myOfficeID,
    officeIDList: this.OfficeIDList
  }
  // return;
  this.spinner = true;
  this.myfolderForm.markAsPristine();
  const result = await this.taskService.renameTasklist(ReqModel).toPromise();
  if (result.status === this.statusConst.statusSuccess) {
    this.spinner = false;
    this.loaderService.hide();
    this.taskListsSharedWithMe = [];
    this.GetTasklistFolderSharedWithMe();
    var obj = {
      id: this.taskListFolderIDForUpdate
    }
    this.taskListSelectedSharedWithMe=false;
    this.getTaskListsSharedWithMe(obj, this.expandedIndex);
    this.toastr.success("Task list update successfully.", '', {
      timeOut: 3000,
    });
    this.close();
  }
  else {
    this.toastr.error("Task list update failed.", '', {
      timeOut: 3000,
    });
    this.spinner = false;
    this.loaderService.hide();
  }
}


  //======Open Task List===========//

  OpenTaskList(Tasklist: any) {
    this.showAddGroupButton = true;
    this.taskListIDSharedWithMe=0;
    this.taskListID = Tasklist.taskListID;
    this.taskListIDforImportTask = Tasklist.taskListID;
    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    this.showMoveToOption = false;
    this.SingleTaskArchived=false;
    this.dueDatetext = "Due Date";
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.getTaskByTaskList();
  }

  taskTypeIDSubFolderID:number=0;

  OpenTaskListSharedWithMe(Tasklist: any) {
    this.showAddGroupButton = true;
    this.taskTypeIDSubFolderID = Tasklist.taskTypeID;
    this.taskListID=0;
    this.taskListIDSharedWithMe = Tasklist.taskListID;
    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    this.showMoveToOption = false;
    this.SingleTaskArchived=false;
    this.dueDatetext = 'Due Date';
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.getTaskByTaskListSharedWithMe();
  }

  reSetFormURL(taskId: any, formURL: any) {
    //let formURL = this.myTaskForm.get('formLink').value;
    if (formURL != undefined && formURL !== '' && formURL != null) {
      const getToken = formURL.split("token=")[1];
      if (getToken !== undefined) {
        const params = decodeURIComponent(getToken);
        const encrptedToken = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
        const decryptedToken = JSON.parse(encrptedToken)
        decryptedToken.taskID = taskId
        decryptedToken.UserID = this.currentUser.UID;
        const jsonString = JSON.stringify(decryptedToken)
        const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
        const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);
        const finalFormURL = formURL.split("token=")[0] + "token=" + encryptedTokenWithEncoding;
        return finalFormURL;
      }
      return formURL;
    }
  }


  showExternalTaskList = [];
  ScheduleTaskList: any = [] = [];
 // totalTask = 0;
  inProgressTask = 0;
  openTask = 0;
  completedTask = 0;
  myFormGroup: FormGroup;
  statusGroup: FormGroup;

  taskListForGroupTrigger:any=[]=[];

  getTaskByTaskList() {
    //this.clearStatus();
    this.dialog.closeAll();
    this.statustext = 'Status';
    this.dueDatetext = 'Due Date';
    this.isDuedate = false;
    this.isOverDue = false;
    this.dateFrom = null;
    this.dateTo = null;
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.preorityArray = [];
    this.IsAssignedToMe = false;
    this.IsAssignedToMyRole = false;
    this.IsCreatedByMe = false;
    this.IsAllTask = false;
    this.isMyTaskFilterSelected = false;
    this.statustype = 0;
    this.ShowNoRecordFound = false;
    this.loaderService.show();

    var taskListIDs:number=0
    if(this.taskListIDSharedWithMe>0){
      taskListIDs=this.taskListIDSharedWithMe;
    }
    if(this.taskListID>0){
      taskListIDs=this.taskListID;
    }
    var ReqModel = {
      taskListID: taskListIDs,//this.taskListID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      moduleID: Number(this.folderId)
    }
    this.taskService.GetTaskGroupsByTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.ShowCustomColumn = true;
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.dataSource = new MatTableDataSource<any>();
          this.myTaskText = response.data.taskListName;
          this.columns = JSON.parse(JSON.stringify(this.columnsCopy));
          if (response.data.taskGroups !== undefined && response.data.taskGroups !== null) {
            response.data.taskGroups = response.data.taskGroups.sort(function (a, b) {
              return a.groupPosition - b.groupPosition;
            });

            const taskFil = response.data.taskGroups.filter(x => x.tasks.length > 0)
            taskFil.map(data => {
              data.tasks.forEach(state => {
                this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

                if (state.status == 0) {
                  this.statusGroup.controls["status" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["status" + state.taskId].setValue(state.status);
                }
                this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

                if (state.priority == 0) {
                  this.statusGroup.controls["priority" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
                }
                if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
                 //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                state.dueDate = state.dueDate+'.000Z';
               }
              })
            })

            response.data.taskGroups.forEach(tg => {

              if (tg.tasks !== undefined && tg.tasks !== null) {
                tg.tasks.forEach(ts => {
                  ts.formLink = this.reSetFormURL(ts.taskId, ts.formLink);
                  if (ts.dueDate!=null && ts.dueDate!=undefined && ts.dueDate!="") {
                    ts.dueDate = moment(ts.dueDate).local().format('YYYY-MM-DD');
                 }
                });
                tg.tasks = tg.tasks.sort(function (a, b) {
                  return a.position - b.position;
                });
              }             
              this.columns[0].groups.push({
                id: tg.taskGroupId,
                title: tg.taskGroupName == "Undefined" ? 'Default Group' : tg.taskGroupName,
                items: tg.tasks,
                dragDisabled: tg.taskGroupName == "Undefined" ? true : false,
                groupPosition: tg.groupPosition,
                processStageID:tg.processStageID,
                  processStageName:tg.processStageName,
                isTriggered:tg.isTriggered,
                groupType:tg.groupType
              });
            });
          }

          this.taskList = response.data.getTaskDetailResponseDTOs;
          this.FieldColumnToogle = response.data.gridSettings;
          this.FieldColumn = response.data.gridSettings;

          if (this.FieldColumn.length > 0) {
            this.FieldColumn = this.FieldColumn.filter(x => x.isDisplay == true);
          }

          if (response.data.taskGroups.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }

          if (response.data.taskGroups.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
          this.taskListForGroupTrigger=response.data.taskGroups;
          if (response.data.taskGroups.length > 0) {
            this.checkIsEntityAttached(response.data.taskGroups);
          }
        }
        else {
          this.paginatorTotalLength = 0;
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }

  checkIsEntityAttached(taskGroups: any, templateRef: TemplateRef<any> = null): any {
    taskGroups.forEach(tg => {
      if (tg.tasks !== undefined && tg.tasks !== null) {
        tg.tasks.forEach(data => {
          this.isEntityIDAttached = data.attachedEntityID > 0;
          this.attachedEntityID = data.attachedEntityID;
          if (this.isEntityAttached == false) {
            this.isEntityAttached = data.entityTypeAttached != 0;
            this.entityTypeAttached = data.entityTypeAttached;
          }
          if (this.isEntityAttached == true && data.entityTypeAttached !== 0) {
            this.isEntityAttached = data.entityTypeAttached !== 0;
            this.entityTypeAttached = data.entityTypeAttached;
          }
          if (this.isEntityAttached == true && this.isEntityIDAttached == true) {
            // return;
          }
        });
      }
    });
    if (this.isEntityAttached == true && this.attachedEntityID == 0 && templateRef != null) {
      this.dialog.open(templateRef, {
        //disableClose: true,
        // hasBackdrop: false
      });
    }
  }

  getTaskByTaskListWhenClearFilter() {
    this.loaderService.show();
    if (this.dueDatetext == 'Today') {
      this.dateFrom = moment().utc().format('YYYY-M-D');
      this.dateTo = moment().utc().format('YYYY-M-D');
    }
    else if (this.dueDatetext == 'Tomorrow') {
      this.dateFrom = moment().add(1, 'day').utc().format('YYYY-M-D');
      this.dateTo = moment().add(1, 'day').utc().format('YYYY-M-D');
    }
    else if (this.dueDatetext == 'This Week') {
      this.dateFrom = moment().startOf('week').utc().format('YYYY-M-D');
      this.dateTo = moment().endOf('week').utc().format('YYYY-M-D');
    }
    else if (this.dueDatetext == 'Next Week') {
      this.dateFrom = moment().add(1, 'week').startOf('week').utc().format('YYYY-M-D');
      this.dateTo = moment().add(1, 'week').endOf('week').utc().format('YYYY-M-D');
    }
    else if (this.dueDatetext == 'Overdue') {
      this.isOverDue = true;
      this.dateFrom = moment().utc().format('YYYY-M-D');
      this.dateTo = moment().utc().format('YYYY-M-D');
    }
    var ReqModel1 = {
      taskListID: this.taskListID,
      //"tasktype": 0,
      moduleID: this.folderId,
      IsFilterApply: true,
      "filters": {
        Keyword: this.value,
        Priority: this.preorityArray,
        Status: Number(this.statustype),
        isOverDue: this.isOverDue,
        "ByDate": {
          "from": this.dateFrom,
          "to": this.dateTo
        }
      },
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.taskService.GetTaskGroupsByTaskList(ReqModel1).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.dataSource = new MatTableDataSource<any>();
          this.myTaskText = response.data.taskListName;
          this.columns = JSON.parse(JSON.stringify(this.columnsCopy));
          if (response.data.taskGroups !== undefined && response.data.taskGroups !== null) {
            response.data.taskGroups = response.data.taskGroups.sort(function (a, b) {
              return a.groupPosition - b.groupPosition;
            });

            const taskFil = response.data.taskGroups.filter(x => x.tasks.length > 0)
            taskFil.map(data => {
              data.tasks.forEach(state => {
                this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

                if (state.status == 0) {
                  this.statusGroup.controls["status" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["status" + state.taskId].setValue(state.status);
                }
                this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

                if (state.priority == 0) {
                  this.statusGroup.controls["priority" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
                }
                if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
                  //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                  state.dueDate = state.dueDate+'.000Z';
               }
              })
            })

            response.data.taskGroups.forEach(tg => {

              if (tg.tasks !== undefined && tg.tasks !== null) {
                tg.tasks.forEach(ts => {
                  ts.formLink = this.reSetFormURL(ts.taskId, ts.formLink);
                  if (ts.dueDate!=null && ts.dueDate!=undefined && ts.dueDate!="") {
                    ts.dueDate = moment(ts.dueDate).local().format('YYYY-MM-DD');
                 }
                });
                tg.tasks = tg.tasks.sort(function (a, b) {
                  return a.position - b.position;
                });
              }
              this.columns[0].groups.push({
                id: tg.taskGroupId,
                title: tg.taskGroupName == "Undefined" ? 'Default Group' : tg.taskGroupName,
                items: tg.tasks,
                dragDisabled: tg.taskGroupName == "Undefined" ? true : false,
                groupPosition: tg.groupPosition,
                processStageID:tg.processStageID,
                processStageName:tg.processStageName,
                isTriggered:tg.isTriggered,
                groupType:tg.groupType
              });
            });
          }
          this.taskList = response.data.getTaskDetailResponseDTOs;
          this.FieldColumnToogle = response.data.gridSettings;
          this.FieldColumn = response.data.gridSettings;

          if (this.FieldColumn.length > 0) {
            this.FieldColumn = this.FieldColumn.filter(x => x.isDisplay == true);
          }
          if (response.data.taskGroups.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
        }
        else {
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });

  }

  getTaskByTaskListSharedWithMe() {
    this.loaderService.show();
    this.dueDatetext = 'Due Date';
    this.isDuedate = false;
    this.isOverDue = false;
    this.dateFrom = null;
    this.dateTo = null;
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.preorityArray = [];
    this.IsAssignedToMe = false;
    this.IsAssignedToMyRole = false;
    this.IsCreatedByMe = false;
    this.IsAllTask = false;
    this.isMyTaskFilterSelected = false;

    this.ShowNoRecordFound = false;
    this.loaderService.show();
    var ReqModel = {
      taskListID: Number(this.taskListIDSharedWithMe),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      moduleID: Number(this.folderId),
      taskTypeID:Number(this.taskTypeIDSubFolderID)
    }
    this.taskService.GetTaskGroupsByTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.ShowCustomColumn = true;
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.dataSource = new MatTableDataSource<any>();
          this.myTaskText = response.data.taskListName;
          this.columns = JSON.parse(JSON.stringify(this.columnsCopy));
          if (response.data.taskGroups !== undefined && response.data.taskGroups !== null) {
            response.data.taskGroups = response.data.taskGroups.sort(function (a, b) {
              return a.groupPosition - b.groupPosition;
            });

            const taskFil = response.data.taskGroups.filter(x => x.tasks.length > 0)
            taskFil.map(data => {
              data.tasks.forEach(state => {
                this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

                if (state.status == 0) {
                  this.statusGroup.controls["status" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["status" + state.taskId].setValue(state.status);
                }
                this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

                if (state.priority == 0) {
                  this.statusGroup.controls["priority" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
                }
                if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
                  //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                 state.dueDate = state.dueDate+'.000Z';
               }
              })
            })

            response.data.taskGroups.forEach(tg => {
              if (tg.tasks !== undefined && tg.tasks !== null) {
                tg.tasks.forEach(ts => {
                  ts.formLink = this.reSetFormURL(ts.taskId, ts.formLink);
                  if (ts.dueDate!=null && ts.dueDate!=undefined && ts.dueDate!="") {
                    ts.dueDate = moment(ts.dueDate).local().format('YYYY-MM-DD');
                 }
                });
                tg.tasks = tg.tasks.sort(function (a, b) {
                  return a.position - b.position;
                });
              }
              this.columns[0].groups.push({
                id: tg.taskGroupId,
                title: tg.taskGroupName == "Undefined" ? 'Default Group' : tg.taskGroupName,
                items: tg.tasks,
                dragDisabled: tg.taskGroupName == "Undefined" ? true : false,
                groupPosition: tg.groupPosition,
                processStageID:tg.processStageID,
                processStageName:tg.processStageName,
                isTriggered:tg.isTriggered,
                groupType:tg.groupType
              });
            });
          }

          this.taskList = response.data.getTaskDetailResponseDTOs;
          this.FieldColumnToogle = response.data.gridSettings;
          this.FieldColumn = response.data.gridSettings;

          if (this.FieldColumn.length > 0) {
            this.FieldColumn = this.FieldColumn.filter(x => x.isDisplay == true);
          }

          if (response.data.taskGroups.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }

          this.taskListForGroupTrigger=response.data.taskGroups;   
          if (response.data.taskGroups.length > 0) {
            this.checkIsEntityAttached(response.data.taskGroups);
          }      
        }
        else {
          this.paginatorTotalLength = 0;
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }

  MailToAssignee(list,tasklistfolder: any, index: number) {
     var ReqModel = {
        taskListID: list.taskListID,        
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        officeIDList: this.OfficeIDList,
        databaseID: Number(this.databaseId)
      };
      this.loaderService.show();
      this.taskService.resendTasklistURL(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) { 
            this.toastr.success('Mail sent to assignee successfully.', '', {
              timeOut: 4000,
            });                      
            this.loaderService.hide();
            var obj = {
            taskListFolderID: tasklistfolder.taskListFolderID
            }
            this.taskListSelected=false;
            this.getTaskLists(obj, this.expandedIndex);           
          } else {
            this.toastr.error('Failed to send mail to assignee.', '', {
              timeOut: 4000,
            }); 
            this.loaderService.hide();
          }
        } else {
          this.toastr.error('Failed to send mail to assignee.', '', {
            timeOut: 4000,
          }); 
          this.loaderService.hide();
        }
      });
  }

  MailToAssigneeSharedWithMe(list,tasklistfolder: any, index: number) {
    var ReqModel = {
       taskListID: Number(list.taskListID),        
       userID: this.currentUser.UID,
       organizationID: Number(this.organizationId),
       officeID: this.myOfficeID,
       officeIDList: this.OfficeIDList,
       databaseID: Number(this.databaseId)
     };
     this.loaderService.show();
     this.taskService.resendTasklistURL(ReqModel).subscribe((response) => {
       if (response != undefined) {
         this.responseHolder = response;
         this.loaderService.hide();
         if (this.responseHolder.status == this.statusConst.statusSuccess) { 
           this.toastr.success('Mail sent to assignee successfully.', '', {
             timeOut: 4000,
           });                      
           this.loaderService.hide();
           var obj = {
            id: tasklistfolder.id
          }
          this.taskListSelectedSharedWithMe=false;
          this.getTaskListsSharedWithMe(obj, this.expandedIndex);         
         } else {
           this.toastr.error('Failed to send mail to assignee.', '', {
             timeOut: 4000,
           }); 
           this.loaderService.hide();
         }
       } else {
         this.toastr.error('Failed to send mail to assignee.', '', {
           timeOut: 4000,
         }); 
         this.loaderService.hide();
       }
     });
 }

  openTaskListUrl(list, isOpen = false) {
    if (list.token != null && isOpen == false) {
      let params = decodeURIComponent(list.token);
      const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
      let decryptedToken = JSON.parse(tokenm);

      decryptedToken.isOpenURL = false;
      decryptedToken.UserID = this.currentUser.UID;
      const jsonString = JSON.stringify(decryptedToken)
      const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
      const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);

      let URL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + encryptedTokenWithEncoding;
      this.clipboard.copy(URL);
      this.toastr.success("Link Copied.", '', {
        timeOut: 3000,
      });

      // let URL = window.location.href.split(window.location.pathname)[0]+"/request/task?token="+list.token;
      // window.open(URL, '_blank');
    }
    else if (list.token != null && isOpen == true) {
      let params = decodeURIComponent(list.token);
      const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
      let decryptedToken = JSON.parse(tokenm);     

      decryptedToken.isOpenURL = true;
      decryptedToken.isLoggedInUser = true;
      decryptedToken.email = sessionStorage.getItem('email');
      const jsonString = JSON.stringify(decryptedToken)
      const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
      const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);

      let URL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + encryptedTokenWithEncoding;
      window.open(URL, '_blank');     
            
      // var ReqModel = {
      //   taskListID: list.taskListID,
      //   email: sessionStorage.getItem('email'),
      //   userID: this.currentUser.UID,
      //   organizationID: Number(this.organizationId),
      //   officeID: this.myOfficeID,
      //   officeIDList: this.OfficeIDList,
      //   databaseID: Number(this.databaseId)
      // };
      // this.loaderService.show();
      // this.taskService.getTasklistInternalUrl(ReqModel).subscribe((response) => {
      //   if (response != undefined) {
      //     this.responseHolder = response;
      //     this.loaderService.hide();
      //     if (this.responseHolder.status == this.statusConst.statusSuccess) {  
      //        let URL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + this.responseHolder.data.token;
      //        window.open(URL, '_blank');           
      //        this.loaderService.hide();
      //     } else {
      //       this.loaderService.hide();
      //     }
      //   } else {
      //     this.loaderService.hide();
      //   }
      // });
    }
  }

  openTaskListUrlTicket(list, isOpen = false) {
    if (list.ticketToken != null && isOpen == false) {
      let params = decodeURIComponent(list.ticketToken);
      const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
      let decryptedToken = JSON.parse(tokenm);

      decryptedToken.isOpenURL = false;
      decryptedToken.UserID = this.currentUser.UID;
      decryptedToken.subFolderID = list.taskTypeID;
      decryptedToken.title = list.taskListName;
      //decryptedToken.folderID = list.folderID;
      const jsonString = JSON.stringify(decryptedToken)
      const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
      const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);

      let URL = window.location.href.split(window.location.pathname)[0] + "/request/tickettask?token=" + encryptedTokenWithEncoding;
      this.clipboard.copy(URL);
      this.toastr.success("Link Copied.", '', {
        timeOut: 3000,
      });
    }
    else if (list.ticketToken != null && isOpen == true) {
      let params = decodeURIComponent(list.ticketToken);
      const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
      let decryptedToken = JSON.parse(tokenm);
    
      decryptedToken.isOpenURL = true;
      decryptedToken.email = sessionStorage.getItem('email');
      decryptedToken.title = list.taskListName;
      const jsonString = JSON.stringify(decryptedToken)
      const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
      const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);

      let URL = window.location.href.split(window.location.pathname)[0] + "/request/tickettask?token=" + encryptedTokenWithEncoding;
      window.open(URL, '_blank');
      //
    }
  }

  openTaskUrl(list) {
      let params = decodeURIComponent(list.token);
      const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
      let decryptedToken = JSON.parse(tokenm);

      //decryptedToken.isOpenURL = false;
      decryptedToken.UserID = this.currentUser.UID;
      const jsonString = JSON.stringify(decryptedToken)
      const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
      const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);

      let URL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + encryptedTokenWithEncoding;
      this.clipboard.copy(URL);
      this.toastr.success("Link Copied Successfully.", '', {
        timeOut: 3000,
      });
  }

  dropTable(event: CdkDragDrop<string[]> = undefined) {
    var itemList = [];
    let taskindex = 1;
    this.columns[0].groups.forEach(tg => {
      if (tg.items !== undefined && tg.items !== null) {
        tg.items.forEach(ts => {
          var obj = {
            taskID: ts.taskId,
            position: taskindex,
            TaskGroupID: ts.taskGroupId
          }
          itemList.push(obj);
          taskindex++;
        });
      }
    });
    //return;
    var taskListIDs:number=0
    if(this.taskListIDSharedWithMe>0){
      taskListIDs=this.taskListIDSharedWithMe;
    }
    if(this.taskListID>0){
      taskListIDs=this.taskListID;
    }
    var ReqModel = {
      taskListID: taskListIDs,//this.taskListID,
      tasks: itemList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    };
    this.loaderService.show();
    this.taskService.reorderTasksLists(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if(this.taskListIDSharedWithMe>0){
            this.getTaskByTaskListSharedWithMe();
          }else{
            this.getTaskByTaskList();
          }           
          //this.getTaskByTaskList();         
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  closeMoveto() {
    this.currentTaskListMoveTo=0;
    this.dialog.closeAll();
  }

  selectedRecordMoveToArray: any = [] = [];
  showMoveToOption: boolean = false;
  ButtonForMoveTo: boolean = false;
  taskListIDMoveTo: number = 0;
  taskListFolderForMoveTo: any = [] = [];
  taskListsForMoveTo: any = [] = [];
  showAllCheckBoxes = false;

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    this.showAllCheckBoxes = !this.showAllCheckBoxes;
    return numSelected === numRows;
  }

  isAllSelectedNew() {
    const numSelected = this.selection.selected.length;
    let numRows = 0;
    this.columns[0].groups.forEach(grp => {
      numRows = numRows + grp.items.length;
    });
    this.showAllCheckBoxes = !this.showAllCheckBoxes;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => {
        this.selection.select(row)
      });
    this.selectedRecordMoveToArray = [];

    if (this.selection.selected.length > 0) {
      for (let i = 0; i < this.selection.selected.length; i++) {
        var taskId;
        if (this.selection.selected[i].taskId == undefined) {
          taskId = this.selection.selected[i].taskID;
        } else {
          taskId = this.selection.selected[i].taskId;
        }
        let ReqModel = {
          selectedRecord: taskId,//this.selection.selected[i].taskId
          isRequired:this.selection.selected[i].isRequired
        };
        this.selectedRecordMoveToArray.push(ReqModel);
      }
      this.showMoveToOption = true;
    }
    else {
      this.showMoveToOption = false;
      this.selectedRecordMoveToArray = [];
    }
  }

  masterToggleNew() {
    this.isAllSelectedNew() ?
      this.selection.clear() :
      this.columns[0].groups.forEach(grp => {
        grp.items.forEach(row => {
          this.selection.select(row)
        });
      });
    this.selectedRecordMoveToArray = [];

    if (this.selection.selected.length > 0) {
      for (let i = 0; i < this.selection.selected.length; i++) {
        var taskId;
        if (this.selection.selected[i].taskId == undefined) {
          taskId = this.selection.selected[i].taskID;
        } else {
          taskId = this.selection.selected[i].taskId;
        }
        let ReqModel = {
          selectedRecord: taskId//this.selection.selected[i].taskId
        };
        this.selectedRecordMoveToArray.push(ReqModel);
      }
      this.showMoveToOption = true;
    }
    else {
      this.showMoveToOption = false;
      this.selectedRecordMoveToArray = [];
    }
  }

  isAllSelectedRow(event, element) {
    var taskId;
    if (element.taskId == undefined) {
      taskId = element.taskID;
    } else {
      taskId = element.taskId;
    }
    let ReqModel = {
      selectedRecord: taskId,//element.taskId
      isRequired:element.isRequired
    };
    if (event.checked) {
      this.selectedRecordMoveToArray.push(ReqModel);
    } else {
      let removeIndex = this.selectedRecordMoveToArray.findIndex((itm) => itm.selectedRecord === taskId);
      if (removeIndex !== -1) this.selectedRecordMoveToArray.splice(removeIndex, 1);
    }
    if (this.selectedRecordMoveToArray.length > 0) {
      this.showMoveToOption = true;
    }
    else {
      this.showMoveToOption = false;
      this.selectedRecordMoveToArray = [];
    }
  }

  moveTo(templateRef: TemplateRef<any>) {
    this.taskListIDMoveTo = 0;
    this.ButtonForMoveTo = false;
    this.expandedIndexmoveTo = 0;
    this.currentTaskListMoveTo=null;
    this.taskListsForMoveTo = [];
    this.taskListSelectedMoveTo=false;
    this.getTaskListFoldersForMoveTo();
    this.dialog.open(templateRef);
  }

  getTaskListFoldersForMoveTo() {   
    this.loaderService.show();
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskListFolders(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskListFolderForMoveTo = response.data.taskListFolders;
        }
        else {
          this.taskListFolderForMoveTo = [];
          this.loaderService.hide();
        }
      }
      else {
        this.taskListFolderForMoveTo = [];
        this.loaderService.hide();
      }
    });
  }

 

  getTaskListsForMoveTo(tasklist: any, index: number) {
    if (this.currentTaskListMoveTo == index) {
      this.taskListSelectedMoveTo = !this.taskListSelectedMoveTo;
    } else {
      this.taskListSelectedMoveTo = true;
    }
    this.currentTaskListMoveTo = index;
    this.ButtonForMoveTo = false;
    this.taskListsForMoveTo = [];
    this.expandedIndexmoveTo = index;
    this.loaderService.show();
    var ReqModel = {
      folderID: tasklist.taskListFolderID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskLists(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskListsForMoveTo = response.data.taskLists;
        }
        else {
          this.taskListsForMoveTo = [];
          this.loaderService.hide();
        }
      }
      else {
        this.taskListsForMoveTo = [];
        this.loaderService.hide();
      }
    });
  }

  

  SelectTaskList(Tasklist: any) {
    if (this.taskListID == Tasklist.taskListID) {
      this.toastr.warning('Task can not add same folder.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.taskListIDMoveTo = Tasklist.taskListID;
    this.ButtonForMoveTo = true;
  }

  MoveToTaskList() {
    var itemList = [];
    if (this.selectedRecordMoveToArray.length > 0) {
      for (var i = 0, len = this.selectedRecordMoveToArray.length; i < len; ++i) {
        var obj = {
          taskID: this.selectedRecordMoveToArray[i].selectedRecord,
          position: i + 1
        }
        itemList.push(obj);
      }
    }
    //return;
    var ReqModel = {
      taskListID: this.taskListIDMoveTo,
      tasks: itemList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    };
    this.loaderService.show();
    this.spinner = true;
    this.ButtonForMoveTo = false;
    this.taskService.taskMovetoTaskList(ReqModel).subscribe((response) => {
      if (response.data == true) {
        this.spinner = false;
        this.toastr.success('Task moved successfully.', '', {
          timeOut: 3000,
        });
        this.closeMoveto();

        if(this.taskListIDSharedWithMe>0){
          this.getTaskByTaskListSharedWithMe();                  
        }
        if(this.taskListIDSharedWithMe==0){
          if (this.taskListID == 0) {
            this.getTaskList(this.pageModelData);
          } else {
            this.getTaskByTaskList();
          }  
        } 
        // if (this.taskListID == 0) {
        //   this.getTaskList(this.pageModelData);
        // } else {
        //   this.getTaskByTaskList();
        // }
        this.selectedRecordMoveToArray = [];
        this.selection.clear();
      } else {
        this.toastr.error('Task move failed.', '', {
          timeOut: 3000,
        });
        this.spinner = false;
        this.ButtonForMoveTo = false;
      }
    })
  }

  AddTaskTemplateMultiple: Boolean = false;

  SaveAsTemplate(templateRef: TemplateRef<any>, tasklist: any) {
    this.AddTaskTemplateMultiple = false;
    //this.taskListFolderID=0;
    this.taskListID = tasklist.taskListID;
    this.categoryType=0;
    let group = {};
    this.addTemplateForm = new FormGroup(group);
    this.showNew = true;
    this.showExisting = false;
    this.createSaveAsTaskTemplate();
    this.getActiveTaskTemplateCategories1();
    this.dialog.open(templateRef,{
      panelClass: 'custom-modalbox',
    }
   );
  }

  updateTaskTemplateTasksButton: boolean = false;

  SaveAsTemplateMultiple(templateRef: TemplateRef<any>) {
    this.AddTaskTemplateMultiple = true;
    let group = {};
    this.addTemplateForm = new FormGroup(group);
    this.createSaveAsTaskTemplate();
    this.showNew = true;
    this.showExisting = false;
    this.updateTaskTemplateTasksButton = false;
    this.selectedTaskCategoryID = 0;
    this.searchTemplateName = "";
    this.getActiveTaskTemplateCategories();
    this.getTaskTemplates();
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  async AddTaskTemplate(data) {
    var itemList = [];
    if (this.AddTaskTemplateMultiple == false) {
      itemList = null;
    }
    if (this.AddTaskTemplateMultiple == true) {
      this.taskListID = 0;
      this.taskListIDSharedWithMe = 0;
      this.showAddGroupButton = false;
      if (this.selectedRecordMoveToArray.length > 0) {
        for (var i = 0, len = this.selectedRecordMoveToArray.length; i < len; ++i) {
          var obj = {
            taskID: this.selectedRecordMoveToArray[i].selectedRecord,
            position: i + 1
          }
          itemList.push(obj);
        }
      }
    }

    this.loaderService.show();
    var ReqModel = {
      taskTemplateName: data.taskTemplateName,
      position: 0,
      folderID: data.folderID,
      taskListID: this.taskListID,
      tasks: itemList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      type:this.categoryType>0?this.categoryType:0
    }
    //return; 
    this.spinner = true;
    this.addTemplateForm.markAsPristine();
    const result = await this.taskService.addTaskTemplate(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
      this.toastr.success("Task template added successfully.", '', {
        timeOut: 3000,
      });
      this.showMoveToOption = false;
      this.selectedRecordMoveToArray = [];
      this.selection.clear();
      this.closeSaveAsTemplate();
    }
    else {
      this.toastr.error("Task template add failed.", '', {
        timeOut: 3000,
      });
      this.showMoveToOption = false;
      this.spinner = false;
      this.loaderService.hide();
    }
  }


  async updateTaskTemplateTasks(data) {
    var itemList = [];
    if (this.AddTaskTemplateMultiple == false) {
      itemList = null;
    }
    if (this.AddTaskTemplateMultiple == true) {
      if (this.selectedRecordMoveToArray.length > 0) {
        for (var i = 0, len = this.selectedRecordMoveToArray.length; i < len; ++i) {
          var obj = {
            taskID: this.selectedRecordMoveToArray[i].selectedRecord,
            position: i + 1
          }
          itemList.push(obj);
        }
      }
    }

    this.loaderService.show();
    var ReqModel = {
      taskTemplateID: this.taslTemplateID,
      tasks: itemList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      TaskListID: this.taskListID
    }
    //return; 
    this.spinner = true;
    this.updateTaskTemplateTasksButton = false;
    // this.addTemplateForm.markAsPristine();
    const result = await this.taskService.updateTaskTemplateTasks(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
      this.toastr.success("Task template update successfully.", '', {
        timeOut: 3000,
      });
      this.showMoveToOption = false;
      this.selectedRecordMoveToArray = [];
      this.selection.clear();
      this.closeSaveAsTemplate();
    }
    else {
      this.toastr.error("Task template add failed.", '', {
        timeOut: 3000,
      });
      this.showMoveToOption = false;
      this.spinner = false;
      this.loaderService.hide();
    }
  }


  ShowNoRecordFoundTaskTemplates: Boolean = false;
  TaskTemplatesList: any = [] = [];
  FilteredTaskTemplatesList: any = [] = [];
  taskListIDforAddTemplate: number = 0;


  ShowTemplate(templateRef: TemplateRef<any>, list: any) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
    this.showAddTemp=false;
    this.AttachChecked=false;
    this.AssigneeChecked=false;
    this.NotifyChecked=false;
    this.taskListIDforAddTemplate = Number(list.taskListID);
    this.getTaskTemplates();
    this.selectedTaskCategoryID = 0;
    this.categoryType=0;
    this.searchTemplateName = "";
    this.getActiveTaskTemplateCategories();
  }

  OpenFromTaskList:boolean=false;
  
  ShowTemplateFromFolder(templateRef: TemplateRef<any>,folderID:number,openFrom,i) {
    this.dialog.open(templateRef, {
      panelClass: 'task_template',
    });
    this.expandedIndex = i;
    this.OpenFromTaskList=openFrom;
    this.AttachChecked=false;
    this.AssigneeChecked=true;
    this.NotifyChecked=false;
    this.showAddTemp=false;
    this.taskListIDforAddTemplate = 0;
    this.getTaskTemplates();
    this.selectedTaskCategoryID = 0;
    this.taskTypeID=0;
    this.selectedTaskListFolderID=folderID;
    this.categoryType=0;
    this.searchTemplateName = "";
    this.addtaskTemplateName="";
    this.getActiveTaskTemplateCategories();
    this.getTaskSubFolderList();
  }

  alltemp:any;
  showAddTemp:boolean=false;

  templateSelected(temp){
    this.showAddTemp=true;
    this.alltemp = temp;
    this.addtaskTemplateName = temp.taskTemplateName;
  }


  async SelectTemplate() {
    if(this.addtaskTemplateName==""){
      this.toastr.warning("Please add Tasklist Name.", '', {
        timeOut: 3000,
      });
      return;
    }

    this.loaderService.show();
    if(this.alltemp){
      var ReqModel = {
        taskListID:  Number(this.taskListIDforAddTemplate),
        taskListName: this.addtaskTemplateName,
        position: 0,
        folderID: this.selectedTaskListFolderID,
        taskTemplateID: this.alltemp.taskTemplateID,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        officeID: this.myOfficeID,
        officeIDList: this.OfficeIDList,
        taskTypeID:this.taskTypeID,
        keepAttached: false,//this.AttachChecked,
        keepAssignee: this.AssigneeChecked,
        keepNotify: this.NotifyChecked,
      }
    }else{
      var ReqModel = {
        taskListID:  Number(this.taskListIDforAddTemplate),
        taskListName: this.addtaskTemplateName,
        position: 0,
        folderID: this.selectedTaskListFolderID,
        taskTemplateID: this.alltemp?.taskTemplateID,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        officeID: this.myOfficeID,
        officeIDList: this.OfficeIDList,
        taskTypeID:this.taskTypeID,
        keepAttached: false,//this.AttachChecked,
        keepAssignee: this.AssigneeChecked,
        keepNotify: this.NotifyChecked,
      }
    }
    // return;
    this.spinner = true;
    const result = await this.taskService.addTaskList(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
     // this.getTaskListFolders();
       if(this.OpenFromTaskList==false){
        var obj = {
          taskListFolderID: this.selectedTaskListFolderID
          }
          this.taskListSelected=false;
          this.getTaskLists(obj, this.expandedIndex);
       }     
       if(this.OpenFromTaskList==true){
        var obj1 = {
          id:  this.selectedTaskListFolderID
        }
        this.taskListSelectedSharedWithMe=false;
        this.getTaskListsSharedWithMe(obj1, this.expandedIndex);
       }
      this.taslTemplateID = 0;
      this.toastr.success("Task Imported successfully.", '', {
        timeOut: 3000,
      });
      this.addtaskTemplateName = "";
      this.alltemp = null;
      this.closeTemplate();
      this.addtaskTemplateName = "";
      this.alltemp = null;
    }
    else {
      this.toastr.error("Task Import failed.", '', {
        timeOut: 3000,
      });
      this.spinner = false;
      this.loaderService.hide();
      this.addtaskTemplateName = "";
      this.alltemp = null;
    }   
  }

  searchTemplateName: string = "";

  // getTaskTemplates() {
  //   this.getActiveTaskTemplateCategories();
  //   this.ShowNoRecordFoundTaskTemplates = false;
  //   this.loaderService.show();
  //   this.filteredTaskCategoryList=[];
  //   this.FilteredTaskTemplatesList =[];
  //   var ReqModel = {
  //     folderID: this.selectedTaskCategoryID>0?this.selectedTaskCategoryID:0,
  //     searchKey: this.searchTemplateName,
  //     userID: this.currentUser.UID,
  //     officeID: Number(this.myOfficeID),
  //     organizationID: Number(this.organizationId),
  //     officeIDList: this.OfficeIDList,
  //     databaseID: Number(this.databaseId),
  //     type:this.categoryType>0?this.categoryType:0,
  //     //folderId:this.selectedTaskCategoryID>0?this.selectedTaskCategoryID:0
  //   }
  //   this.taskService.getTaskTemplates(ReqModel).subscribe(response => {
  //     if (response != undefined) {
  //       this.responseHolder = response;
  //       this.loaderService.hide();
  //       if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
  //         this.TaskTemplatesList = response.data;
  //         if(this.categoryType==0){
  //           this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 0);
  //           const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
  //           this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
  //         }
  //         if(this.categoryType==1){
  //           this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 1);
  //           const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
  //           this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
  //         }
  //         if(this.categoryType==2){
  //           this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 2);
  //           const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
  //           this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
  //          // this.FilteredTaskTemplatesList = this.TaskTemplatesList;
  //         }
  //         if (this.TaskTemplatesList.length > 0) {
  //           this.ShowNoRecordFoundTaskTemplates = false;
  //         } else {
  //           this.ShowNoRecordFoundTaskTemplates = true;
  //         }

         
  //       }
  //       else {
  //         this.ShowNoRecordFoundTaskTemplates = true;
  //         this.TaskTemplatesList = [];
  //         this.FilteredTaskTemplatesList = [];
  //         this.loaderService.hide();
  //       }
  //     }
  //     else {
  //       this.ShowNoRecordFound = true;
  //       this.loaderService.hide();
  //     }
  //   });
  // }

  getTaskTemplates() {
    this.ShowNoRecordFoundTaskTemplates = false;
    this.loaderService.show();
    this.filteredTaskCategoryList = [];
    this.FilteredTaskTemplatesList = [];
    var ReqModel = {
      folderID: this.selectedTaskCategoryID > 0 ? this.selectedTaskCategoryID : 0,
      searchKey: this.searchTemplateName,
      userID: this.currentUser.UID,
      officeID: Number(this.myOfficeID),
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      type: this.categoryType > 0 ? this.categoryType : 0,
      //folderId:this.selectedTaskCategoryID>0?this.selectedTaskCategoryID:0
    };
  
    this.getActiveTaskTemplateCategories().subscribe(() => {
      this.taskService.getTaskTemplates(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
            this.TaskTemplatesList = response.data;
            if (this.categoryType == 0) {
              this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 0);
              const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
              this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
            }
            if (this.categoryType == 1) {
              this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 1);
              const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
              this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
            }
            if (this.categoryType == 2) {
              this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 2);
              const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
              this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
              // this.FilteredTaskTemplatesList = this.TaskTemplatesList;
            }
            if (this.TaskTemplatesList.length > 0) {
              this.ShowNoRecordFoundTaskTemplates = false;
            } else {
              this.ShowNoRecordFoundTaskTemplates = true;
            }
          } else {
            this.ShowNoRecordFoundTaskTemplates = true;
            this.TaskTemplatesList = [];
            this.FilteredTaskTemplatesList = [];
            this.loaderService.hide();
          }
        } else {
          this.ShowNoRecordFound = true;
          this.loaderService.hide();
        }
      });
    });
  }

  GetTasklistFolderSharedRolesList:any=[]=[];
  showSharedWithFolder:boolean=false;

   GetTasklistFolderSharedRoles(taskListFolderID) {
    this.GetTasklistFolderSharedRolesList=[];
     this.showSharedWithFolder=false;   
    var ReqModel = {
      tasklistFolderID:Number(taskListFolderID),          
      userID: this.currentUser.UID,
      officeID: Number(this.myOfficeID),
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),      
      };       
      this.taskService.getTasklistFolderSharedRoles(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;        
          if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
            this.GetTasklistFolderSharedRolesList = response.data;
            if(this.GetTasklistFolderSharedRolesList.length>0){
              this.showSharedWithFolder=false;
              this.GetTasklistFolderSharedRolesList.forEach(e => {
               e.shortName=e.roleName.match(/\b(\w)/g).join('');
               e.imageUrl="";
              });  
            }else{
               this.showSharedWithFolder=true;
            }
           } else {        
            this.showSharedWithFolder=true;   
            this.GetTasklistFolderSharedRolesList = [];
          }
        } else {
          this.showSharedWithFolder=true;
          this.GetTasklistFolderSharedRolesList = []; 
        }
      });
 
  }

  timeout = null;

  searchTemplate(val) {
    if (val.length >= 2) {
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.searchTemplateName = val;
          this.getTaskTemplates();
        }, 500);
      } else {

      }
    } else {
      this.searchTemplateName = "";
      this.getTaskTemplates();
    }
  }

  showNew: boolean = false;
  showExisting: boolean = false;

  getTabDetails(event) {
    this.updateTaskTemplateTasksButton = false;
    this.taslTemplateID = 0;
    this.selectedTemplate=[];
    this.TaskTemplatesList=[];
    if (event.tab.textLabel == "New" || event.index == 0) {
      this.showNew = true;
      this.showExisting = false;
      this.getActiveTaskTemplateCategories1();
    }

    if (event.tab.textLabel == "Update Existing" || event.index == 1) {
      this.showNew = false;
      this.showExisting = true;
    }
  }

  selectedsharedAccessRole: any = [];
  sharedAccessRoleList: any = [];
  isRolePopup: boolean = false;
  isShare: boolean = false;
  showAddButton = false;
  actionTypeArray: string[];



  getSharedAccessRoles(searchValue: any) {
    this.sharedAccessRoleList = [];
    if (searchValue.length > 1) {
      var ReqModel = {
        databaseID: Number(this.databaseId),
        organizationID: Number(this.organizationId),
        userID: this.currentUser.UID,
        searchValue: searchValue
      }
      this.taskService.getSharedAccessRoles(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.sharedAccessRoleList = response.data;
          }
        }
      });
    }
  }

  RoleSelectedForSharedAccess(roleSelected: any) {
    let role = this.selectedsharedAccessRole.find(m => m.shareToID == roleSelected.roleID);
    if (roleSelected.roleID == 0) {
      let newRole = this.selectedsharedAccessRole.find(m => m.name.toLowerCase() == roleSelected.name.toLowerCase());
      if (newRole == undefined) {
        this.selectedsharedAccessRole.push({
          name: roleSelected.roleName,
          // email: '',
          // img: '', 
          // isShared:this.isShare,
          // shortName:'',
          shareToID: roleSelected.roleID,
          shareToType: 2,
          actionType: 1
        });
        if (this.selectedsharedAccessRole.length > 0) {
          this.showAddButton = true;
        }
        if (this.selectedsharedAccessRole.length == 0) {
          this.showAddButton = false;
        }
      }
      return;
    }

    if (role == undefined || role == '' || role == null) {
      this.selectedsharedAccessRole.push({
        name: roleSelected.roleName,
        // email: '',
        // img: '', 
        // isShared:this.isShare,
        // shortName:'',
        shareToID: roleSelected.roleID,
        shareToType: 2,
        actionType: 1
      });
    }

    if (this.selectedsharedAccessRole.length > 0) {
      this.showAddButton = true;
    }
    if (this.selectedsharedAccessRole.length == 0) {
      this.showAddButton = false;
    }
  }


  onclickRole(event: any) {
    this.sharedAccessRoleList = [];
    // var reqModel={
    //   searchValue: ""
    // }   
    // this.taskService.getSharedAccessRoles(reqModel).subscribe(response => {
    //   if (response != undefined) {
    //     this.responseHolder = response;
    //     if (this.responseHolder.status == this.statusConst.statusSuccess) {
    //       this.sharedAccessRoleList = response.data;
    //     }
    //     else {
    //     }
    //   }
    // });
  }



  AddRoleForSeletedFolder() {
    this.spinner = true;
    this.showAddButton = false;
    var shareTo = [];
    if (this.selectedsharedAccessRole.length > 0) {
      for (let i = 0; i < this.selectedsharedAccessRole.length; i++) {
        var obj = {
          shareID: 0,
          shareToID: Number(this.selectedsharedAccessRole[i].shareToID),
          shareToType: Number(this.selectedsharedAccessRole[i].shareToType),
          actionType: Number(this.selectedsharedAccessRole[i].actionType)
        }
        shareTo.push(obj);
      }
    }
    var ReqModel = {
      id: this.taskListFolderID,
      userID: this.currentUser.UID,
      shareTo: shareTo,//this.selectedsharedAccessRole,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID
    }
    this.taskService.shareTaskListFolder(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.spinner = false;
          this.loaderService.hide();
          this.closeRole();
          this.toastr.success('Folder shared successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.spinner = false;
          this.loaderService.hide();
          this.closeRole();
        }
      }
    });
  }

  closeRole() {
    this.selectedsharedAccessRole = [];
    this.showAddButton = false;
    this.taslTemplateID = 0;
    this.taskListFolderID = 0;
    this.dialog.closeAll();
  }

  getActionType(actionType) {
    // if(actionType==-1)
    // return this.actionTypeArray= ["Remove"];
    // if(actionType==0)
    // return this.actionTypeArray= ["Viewer"];
    if (actionType == 1)
      return this.actionTypeArray = ["Editor"]
  }

  actionRoleSelected(action, actionType, shareToID) {
    this.selectedsharedAccessRole.find(m => m.shareToID == shareToID).actionType = actionType;
  }


  removeRoles(item: any, isRolePopup: boolean) {
    if (isRolePopup) {
      const index = this.selectedsharedAccessRole.indexOf(item);
      if (index >= 0) {
        this.selectedsharedAccessRole.splice(index, 1);
      }
    }
    if (this.selectedsharedAccessRole.length > 0) {
      this.showAddButton = true;
    }
    if (this.selectedsharedAccessRole.length == 0) {
      this.showAddButton = false;
    }
  }


  GetTasklistFolderSharedWithMe() {
    var ReqModel = {
      taskListFolderID: 0,
      taskListFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      permissionType: 0,
      officeID: this.myOfficeID
    }
    this.taskService.getTasklistFolderSharedWithMe(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskListFolderSharedWithMe = response.data;
          
          // if(this.receivedLinkData!=undefined){
          //   if(this.receivedLinkData.isSharedTasklist==true){
          //     var CheckRecord=[];
          //     CheckRecord = response.data.filter(x=>x.id==this.receivedLinkData.folderID);
          //     if(CheckRecord.length>0){
          //       const index = response.data.findIndex(x => x.id === this.receivedLinkData.folderID);
          //       this.receivedLinkData.id=this.receivedLinkData.folderID;
          //       this.getTaskListsSharedWithMe(this.receivedLinkData,index);
          //     }
          //   }           
          // }
        }
        else {
          this.taskListFolderSharedWithMe = [];
          this.loaderService.hide();
        }
      }
      else {
        this.taskListFolderSharedWithMe = [];
        this.loaderService.hide();
      }
    });
  }




  showAddGroupButton: boolean = false;

  createGroup() {
    this.loaderService.show();
    var taskListIDs:number=0
      if(this.taskListIDSharedWithMe>0){
        taskListIDs=this.taskListIDSharedWithMe;
      }
      if(this.taskListID>0){
        taskListIDs=this.taskListID;
      }

    var ReqModel = {
      groupID: 0,
      groupName: "Group1",
      position: (Math.max(...(this.columns[0].groups.map(m => m.groupPosition))) + 1),
      taskListID:taskListIDs,//this.taskListID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    //return; 
    this.taskService.addEditTaskGroup(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.toastr.success('Group added successfully.', '', {
          timeOut: 3000,
        });
        if(this.taskListIDSharedWithMe>0){
          this.getTaskByTaskListSharedWithMe();
         }else{
          this.getTaskByTaskList();
        }  
        this.loaderService.hide();
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  values: any;

  onChangeGroupName(event: any, group: any) {
    this.values = event.target.value;
    if (this.values == "") {
      this.toastr.warning("Group name can not be blank.", '', {
        timeOut: 3000,
      });
    }
    if (event != undefined && this.values != "") {
      this.loaderService.show();
      var taskListIDs:number=0
      if(this.taskListIDSharedWithMe>0){
        taskListIDs=this.taskListIDSharedWithMe;
      }
      if(this.taskListID>0){
        taskListIDs=this.taskListID;
      }
      var ReqModel = {
        groupID: group.id,
        groupName: this.values,
        position: 1,
        taskListID: taskListIDs,//this.taskListID,
        userID: this.currentUser.UID,
        officeID: this.myOfficeID,
        organizationID: Number(this.organizationId),
        officeIDList: this.OfficeIDList,
        databaseID: this.databaseId
      }
      //return;
      this.taskService.addEditTaskGroup(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success('Group renamed successfully.', '', {
              timeOut: 3000,
            });
            this.loaderService.hide();
            if(this.taskListIDSharedWithMe>0){
              this.getTaskByTaskListSharedWithMe();
            }else{
              this.getTaskByTaskList();
            }  
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  };


  removeGroup(task: any) {
    const message = `Are you sure you want to delete this group and all associated tasks?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var taskListIDs:number=0
          if(this.taskListIDSharedWithMe>0){
            taskListIDs=this.taskListIDSharedWithMe;
          }
          if(this.taskListID>0){
            taskListIDs=this.taskListID;
          }
          var ReqModel = {
            groupID: task.id,
            taskListID: taskListIDs,//this.taskListID,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.taskService.removeTaskGroup(ReqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.responseHolder = response;
                this.toastr.success('Group removed successfully.', '', {
                  timeOut: 3000,
                });
                this.loaderService.hide();
                if(this.taskListIDSharedWithMe>0){
                  this.getTaskByTaskListSharedWithMe();
                }else{
                  this.getTaskByTaskList();
                }                
              } else {
                this.loaderService.hide();
              }
            } else {
              this.loaderService.hide();
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  openDialogAddWithRef() {
    const dialogRef = this.dialog.open(AddTaskTempCategoryComponent, {
      data: {
        categoryType: this.categoryType
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getActiveTaskTemplateCategoriesAfterAdd(result);
      }
    });
  }

  SelectValue: any = 1;

  getActiveTaskTemplateCategoriesAfterAdd(categoryName: string) {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      type: this.categoryType > 0 ? this.categoryType : 0
    }
    this.taskService.getActiveTaskTemplateCategories(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskCategoryList = response.data;
          this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == this.categoryType);
          var check = [];
          check = this.taskCategoryList.filter(x => x.taskTemplateCategoryName.toLowerCase() == categoryName.toLowerCase());
          if (check.length > 0) {
            this.addTemplateForm.controls['folderID'].setValue(check[0].taskTemplateCategoryID);
          }
        }
        else {
          this.taskCategoryList = [];
          this.filteredTaskCategoryList = [];
        }
      }
      else {
        this.taskCategoryList = [];
        this.filteredTaskCategoryList = [];
      }
    });
  }


  taskStatusColors = ['#8f8f8f', '#4f66ff', '#fdab3d',  '#00c875', '#db241c']
  taskPriorityColors = ['#8f8f8f', '#fdab3d', '#4f66ff', '#00c875', '#db241c']

  taskPriorityNameColorCode = [
    {
      val: 1,
      name: 'Lowest',
      color: '#8f8f8f',
      icon: 'keyboard_double_arrow_down'
    },
    {
      val: 2,
      name: 'Low',
      color: '#fdab3d',
      icon: 'keyboard_double_arrow_down'
    },
    {
      val: 3,
      name: 'Medium',
      color: '#1dcd33',
      icon: 'keyboard_double_arrow_up'
    },
    {
      val: 4,
      name: 'High',
      color: '#d31e16bf',
      icon: 'keyboard_double_arrow_up'
    },
    {
      val: 5,
      name: 'Highest',
      color: '#db241c',
      icon: 'keyboard_double_arrow_up'
    }
  ]

  getPredefinePriority() {

  }


  statusConstInProgress: any;
  statusConstInOpen: any;
  statusConstCompleted: any;
  completedStatusID: any = 0;
  selectedtask: number = 0;


  getPredefinedaskStatus() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: Number(this.myOfficeID),
    }
    this.loaderService.show();
    this.coreService.taskStatus(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {

          this.taskStatusList = this.responseHolder.data;
          this.taskStatusList.map(data =>{
            if(data.taskStatusConstantName == 'blocked'){
              data.taskStatusName = 'Stuck';
            }
          });        

          this.taskStatusList.forEach((data, index) => {

            data.background = this.taskStatusColors[index];
            if (data.taskStatusConstantName == 'open') {
              this.statusConstInOpen = data.taskStatusID
            }
            if (data.taskStatusConstantName == 'inprogress') {
              this.statusConstInProgress = data.taskStatusID
            }
            if (data.taskStatusConstantName == 'blocked') {
              this.statusConstCompleted = data.taskStatusID
            }
            if (data.taskStatusConstantName == 'completed') {
              this.statusConstCompleted = data.taskStatusID
            }
            if (data.taskStatusConstantName == 'declined') {
              this.statusConstCompleted = data.taskStatusID
            }
          })
          this.completedStatusID = this.responseHolder.data.find(m => m.taskStatusConstantName == "completed").taskStatusID;
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  getBackground(stat) {
    switch (stat) {
      case 1:
        return this.taskStatusColors[0];

      case 2:
        return this.taskStatusColors[1];

      case 3:
        return this.taskStatusColors[2];

      case 4:
        return this.taskStatusColors[3];

      case 5:
        return this.taskStatusColors[4];

      default:
        return "#000000"

    }

  }

  onTaskListStatusChange($event: any, task: any) {
    let requestModal: any;
    this.encryptedUserToken = sessionStorage.getItem("userToken");
    this.userToken = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.encryptedUserToken);
    this.decodedUserData = jwt_decode(this.userToken);
    const email = this.encryptedUserToken = sessionStorage.getItem("email");

    let taskStatus = [{
      taskID: task.taskId,
      status: $event,
      position: task.position,
      userID: this.currentUser.UID,
      organizationID: 0,
      officeID: 0,
      officeIDList: [0],
      databaseID: 0
    }]

    let ReqModel = {
      taskListID: this.taskListID,
      isUpdateTaskListStatus: false,
      tasks: taskStatus,

      name: this.decodedUserData.Name,
      email: email,
      emailOfPersonDoingTask: email,
      entityTypeAttached: 0, //3C TYPE
      attachedEntityID: 0, // 3C id

      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: Number(this.myOfficeID),
      officeIDList: [0],
      databaseID: 0
    }

    let taskStatusWithFilter = {
      taskID: task.taskId,
      status: $event,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: [0],
      databaseID: 0
    }
    if (this.IsAllTask == true || this.IsAssignedToMe == true || this.IsAssignedToMyRole == true || this.IsCreatedByMe == true) {
      this.formsService.UpdateSingleTaskStatus(taskStatusWithFilter).subscribe((response) => {
        if (response != undefined) {
          if (response.status == this.statusConstant.statusSuccess) {
            this.loaderService.hide();
            this.toastr.success("Details updated successfully.");
            this.getTaskByTaskList();
          } else {
            this.loaderService.hide();
            this.toastr.error("Status updated failed.")
          }
        } else {
          this.loaderService.hide();
          this.toastr.success("Status updated failed.")
        }
      });
    } else {
      this.formsService.UpdateTaskOrTaskListstatus(ReqModel).subscribe((response) => {
        if (response != undefined) {
          if (response.status == this.statusConstant.statusSuccess) {
            this.loaderService.hide();
            this.toastr.success("Details updated successfully.");
            this.getTaskByTaskList();
          } else {
            this.loaderService.hide();
            this.toastr.error("Status updated failed.")
          }
        } else {
          this.loaderService.hide();
          this.toastr.success("Status updated failed.")
        }
      });

    }
  }



  onTaskListPriorityChange($event: any, task: any) {
    this.encryptedUserToken = sessionStorage.getItem("userToken");
    this.userToken = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.encryptedUserToken);
    this.decodedUserData = jwt_decode(this.userToken);

    var ReqModel = {
      "taskID": task.taskId,
      "priority": $event,
      "userID": this.currentUser.UID,
      "organizationID": Number(this.organizationId),
      "officeID": Number(this.myOfficeID),
      "officeIDList": [
        0
      ],
      "databaseID": 0
    }
    this.formsService.UpdateTaskPriority(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          this.toastr.success("Details updated successfully.");

        } else {
          this.loaderService.hide();
          this.toastr.error("Status updated failed.")
        }
      } else {
        this.loaderService.hide();
        this.toastr.success("Status updated failed.")
      }
    });
  }

  ///  ============ Custom Column =====================//

  FieldColumnToogle: any = [] = [];
  SubmitColumnsButton: boolean = false;
  folderListForID: any = [] = [];
  modulename: string = "";
  ToogleColumnFields: any = [] = [];
  folderId: number = 0;
  ShowCustomColumn: boolean = false;
  FieldColumn: any = [] = [];

  customizeColumn(templateRef: TemplateRef<any>) {
    this.SubmitColumnsButton = false;
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  closeCustomeColumn() {
    this.SubmitColumnsButton = false;
    this.taslTemplateID = 0;
    this.taskListFolderID = 0;
    this.dialog.closeAll();
  }

  changedToggle(item, event) {
    this.SubmitColumnsButton = true;
    this.FieldColumnToogle.find((x) => x.fieldID == item.fieldID).isDisplay = event.checked;
    // this.SubmitColumnsButton=true;
    // //this.folderListForID = JSON.parse(sessionStorage.getItem("menuModules"));  
    // var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    // var modulename = menuModulesList.filter(x => (x.mainModuleName.toLowerCase() == "New Task".toLowerCase() || "Task".toLowerCase()));  
    // if (modulename[0].mainModuleName == ModuleName.Core) {
    //   var data= this.folderListForID.filter(x => x.mainModuleName === ModuleName.Core);
    //   this.folderId=data[0].folderID;    
    //   this.ToogleColumnFields;
    //   this.ToogleColumnFields.forEach((s) => {
    //     if (s.FieldID === item.fieldID) {
    //       s.FieldID = item.fieldID;
    //       s.FolderID = this.folderId;//17;
    //       s.IsDisplay = event.checked;
    //       s.ViewOrder = item.viewOrder;
    //     }
    //   });
    // } 
  }

  onSubmitColumns() {
    this.SubmitColumnsButton = false;
    if (this.FieldColumnToogle.length > 0) {
      var customizationGridUserSetting = [];
      this.FieldColumnToogle.forEach((s) => {
        var obj = {
          fieldID: s.fieldID,
          folderID: this.folderId,
          isDisplay: s.isDisplay,
          viewOrder: s.viewOrder
        }
        customizationGridUserSetting.push(obj);
      });
      var taskListIDs:number=0
      if(this.taskListIDSharedWithMe>0){
        taskListIDs=this.taskListIDSharedWithMe;
      }
      if(this.taskListID>0){
        taskListIDs=this.taskListID;
      }
      var reqModel = {
        userID: this.currentUser.UID,
        taskListID: taskListIDs,//this.taskListID,
        databaseID: Number(this.databaseId),
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        officeIDList: this.OfficeIDList,
        customizationGridUserSetting: customizationGridUserSetting
      }
      //return;
      this.loaderService.show();
      this.coreService.updateTaskListGridCustomizedSetting(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            this.toastr.success('Task List Grid Customized successfully.', '', {
              timeOut: 3000,
            });
            this.closeCustomeColumn();
            this.getTaskByTaskList();
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }

  }

  getFieldType(FieldColumn, item) {
    if (!item?.customFieldsData?.fields) return false;
    const field = item.customFieldsData.fields.find(x => x.fieldID === FieldColumn.fieldID);    
    if (!field) return false;
    return field.fieldName === "Email";
  }


  getFieldColumnValues(FieldColumn, item) {
    if (item.customFieldsData != null) {

      var data = [];
      data = item.customFieldsData?.fields.filter(x => x.fieldID == FieldColumn.fieldID);
      if (data != undefined) {
        if (data.length > 0) {
          if (data[0].fieldName == "Type" && data[0].fieldTypeName == "Dropdown") {
            var checkdrp = []
            checkdrp = this.AllTypeList.filter(x => x.subFolderID == Number(data[0].fieldValue))
            if (checkdrp.length > 0) {
              return checkdrp[0].folderName;
            } else {
              return '--';
            }
          }
          if (data[0].fieldTypeName == "Date") {
            if (data[0].fieldValue != "") {
              return this.datePipe.transform(data[0].fieldValue, 'MM-dd-yyyy');;
            } else {
              return '--';
            }
          }
          if (data[0].fieldValue != "") {
            return data[0].fieldValue;
          } else {
            return '--';
          }
        } else {
          return '--';
        }
      }

    }
  }

  AllTypeList: any = [] = [];
 
  closeEmailPopup() {
    this.dialog.closeAll();
    this.verifyToken = 0;
    this.showMobile = false;
  }
  
  getEmailVerified() {
    let emailVerified: boolean;
    const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    emailVerified = regexp.test(this.userEmailForCode);
    this.isEmailVerified = emailVerified;
  }

  spinner1: boolean = false;

  getConcernedConfirmation() { 
    this.dialog.closeAll();
    this.save3cNew();
  }

  getTokenEmail(value: MatRadioChange) {
    this.showEmail = true;
    this.showMobile = false;
   }

  getTokenMobile(value: MatRadioChange) {
    this.showEmail = false;
    this.showMobile = true;   
  }
 
  GetExterURLToken() {
    if (this.showMobile == true) {
      if (this.authenticationMobile == "") {
        this.toastr.warning('Please provide valid mobile no.', '', {
          timeOut: 3000,
        });
        return;
      }
    }
    if (this.showEmail == false) {
      var ReqModel = {
        email: this.userEmailForCode,
        organizationID: Number(this.organizationId),
        officeID: Number(this.myOfficeID),
      }      
      this.loaderService.show();
      this.formsService.GetExterURLToken(ReqModel).subscribe((response) => {
        if (response != undefined) {
          if (response.status == this.statusConstant.statusSuccess && response.data != null) {           
            this.loaderService.hide();
            this.verifyToken = response.data;
          }
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      });
    }

    if (this.showMobile == true) {
      var ReqModel1 = {
        mobileNo: this.authenticationMobile,
        organizationID: Number(this.organizationId),
        officeID: Number(this.myOfficeID),
      }    
      this.loaderService.show();
      this.formsService.GetExterURLToken(ReqModel1).subscribe((response) => {
        if (response != undefined) {
          if (response.status == this.statusConstant.statusSuccess && response.data != null) {          
            this.loaderService.hide();
            this.verifyToken = response.data;
          }
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      });
    }
  }
  save3cNew(_tasklistURL: string = '') {
    let reqModel = {
      userID: this.currentUser.UID,
      name: this.userFullName,
      email: this.userEmailForCode,
      databaseID: 0,
      organizationID: this.organizationId,
      officeID: this.myOfficeID,
      EntityTypeAttached: this.entityTypeAttached,
      AttachedEntityID: this.attachedEntityID,
      TaskListID: this.taskListID
    }

    this.formsService.Save3cNew(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();        
          this.toastr.success('Concerned person added successfully.', '', {
            timeOut: 3000,
          });
          this.getTaskByTaskList();
        }
      }
    });
  }

  // get all created Feilds
  getAllFolderFields() {
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    var reqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      folderID: this.folderId,//17;
      subFolderID: 0,
      fieldID: 0,
      requestFrom: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.coreService.getCoreFeildList(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.AllTypeList = response.data.types;
        }
      }
    });
  }

  categoryType: number = 0;
  OnCategoryChange(categoryTypeValue: number) {
     this.TaskTemplatesList=[];
    this.categoryType = categoryTypeValue;
    this.getActiveTaskTemplateCategories1();
   // this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == this.categoryType);
  }

  

  onTaskListTabChange($event) {
    this.selectedTaskCategoryID = 0;
    
    const textLabel = $event.value;
    const categoryValue = textLabel == 'My Template' ? 0 : textLabel == 'Organization' ? 2 : 1;
    this.categoryType = categoryValue;
    this.getTaskTemplates();
    // this.OnCategoryChange(categoryValue);
    // const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
    // this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
  }


  sendManualTaskReminder(templateRef: TemplateRef<any>,task:any) {
    this.SubmitColumnsButton = false;
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
    this.repeatTaskEmail="";
    this.getTaskDetailByID(task);    
    
    if(task.taskId == undefined){
      this.TaskReminderTaskId=task.taskID;
    }else{
      this.TaskReminderTaskId=task.taskId;
    }
    this.SubmitColumnsButton=false;
  }

  // //categoryValue:number=0;
  // sendManualTaskReminder(task) {
  //   const message = `Are you sure you want to send reminder for this task?`;
  //   const title = `Confirm`;
  //   const dialogData = new ConfirmDialogModel(title, message);   
  //   const dialogRef = this.dialog.open(ConfirmDialogComponent, {
  //     panelClass: 'edituserdetails',
  //     maxWidth: '1000px',
  //     maxHeight: '500px',
  //     data: dialogData,
  //   });
  //   dialogRef.beforeClosed().subscribe(async (dialogResult) => {
  //     try {
  //       if (dialogResult) { 
  //         var taskId=0;
  //         if(task.taskId == undefined){
  //           taskId=task.taskID;
  //         }else{
  //           taskId=task.taskId;
  //         }
  //         var reqModel={
  //           taskID: taskId,   
  //           emails: 'jenny@mailinator.com,jeremy@mailinator.com',       
  //           userID: this.currentUser.UID,  
  //           officeID: this.myOfficeID,    
  //           organizationID: Number(this.organizationId),
  //           officeIDList: this.OfficeIDList,
  //           databaseID:this.databaseId
  //         }          
  //         this.loaderService.show();
  //         this.taskService.SendManualTaskReminderService(reqModel).subscribe((response) => {
  //           if (response != undefined) {
  //             this.responseHolder = response;
  //             if (this.responseHolder.status == this.statusConst.statusSuccess) {
  //               this.loaderService.hide();
  //               this.toastr.success('Task reminder send successfully.', '', {
  //                 timeOut: 3000,
  //               });
  //              } else {
  //               this.loaderService.hide();
  //               this.toastr.error('Task reminder failed.', '', {
  //                 timeOut: 3000,
  //               });
  //             }
  //           } else {
  //             this.loaderService.hide();
  //             this.toastr.error('Task reminder failed.', '', {
  //               timeOut: 3000,
  //             });
  //           }
  //         });
  //       }
  //     } catch (e) {
  //       Observable.throw(e);
  //     }
  //   });
  // }

  closeSendReminder(){
    this.SubmitColumnsButton = false;
    this.taslTemplateID = 0;
    this.taskListFolderID = 0;
    this.TaskReminderTaskId=0;
    this.dialog.closeAll();
  }

  taskDetailList: any = [] = [];
  getTaskAssignedEntityInDetails: any = [] = [];
  getTaskAttachedEntityInDetails: any = [] = [];
  entityTypeAssignee: number = 2;
  taskAssignedEntity: any = [] = [];
  taskAttachedEntity: any = [] = [];
  repeatTaskEmail:string="";
  TaskReminderTaskId:number=0;

  getTaskDetailByID(task) {  
    var taskId=0;
    if(task.taskId == undefined){
        taskId=task.taskID;
     }else{
        taskId=task.taskId;
    }
    this.loaderService.show();
    var ReqModel={
       taskID: taskId,
       userID: this.currentUser.UID,
       officeID: this.myOfficeID,
       organizationID: Number(this.organizationId),
       officeIDList: this.OfficeIDList
    }
    this.coreService.getTaskDetailByID(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskDetailList = response.data;   
         
          var data = JSON.parse(this.taskDetailList.notifyData);

          if(data!=null){
            this.repeatTaskEmail=data.NotifyEmails;
            this.SubmitColumnsButton=true;
            this.loaderService.hide();
            return;
          }
          this.getTaskAssignedEntityInDetails = this.taskDetailList.taskAssignedEntity;
          this.getTaskAttachedEntityInDetails = this.taskDetailList.taskAttachedEntity;
         
          this.entityTypeAssignee = this.taskDetailList.entityTypeAssignee;
          this.entityTypeAttached = this.taskDetailList.entityTypeAttached;


          if (this.getTaskAssignedEntityInDetails.length > 0) {
            // Contact-1,Role-2,Email-3,User-4,RelationShip-5
            // Added For Contact
            if (this.entityTypeAssignee == 1) {             
              for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i) {                
                if(this.getTaskAssignedEntityInDetails[i].assigneeEmail!=""){
                  this.repeatTaskEmail+= this.getTaskAssignedEntityInDetails[i].assigneeEmail+','; 
                }               
              }
            }           

            // Added For Email
            if (this.entityTypeAssignee == 3) {            
              for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i) {               
                if(this.getTaskAssignedEntityInDetails[i].email!=""){
                  this.repeatTaskEmail+= this.getTaskAssignedEntityInDetails[i].email+','; 
                }              
              }
            }

            // Added For User
            if (this.entityTypeAssignee == 4) {            
              for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i) {               
                if(this.getTaskAssignedEntityInDetails[i].assigneeEmail!=""){
                  this.repeatTaskEmail+= this.getTaskAssignedEntityInDetails[i].assigneeEmail+','; 
                }                
              }
            }
            if (this.entityTypeAssignee == 5) {             
              for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i) {                
                if(this.getTaskAssignedEntityInDetails[i].assigneeEmail!=""){
                  this.repeatTaskEmail+= this.getTaskAssignedEntityInDetails[i].assigneeEmail+','; 
                }                
              }
            }           
          }                 

          if (this.getTaskAttachedEntityInDetails.length > 0) {
            // Core-1,Contact-2,Company-3
            // Added For Core
            if (this.entityTypeAttached == 1) {             
              for (var i = 0, len = this.getTaskAttachedEntityInDetails.length; i < len; ++i) {               
                if(this.getTaskAttachedEntityInDetails[i].attachedEntityEmail!=""){
                  this.repeatTaskEmail+= this.getTaskAttachedEntityInDetails[i].attachedEntityEmail+','; 
                }                
              }
            }

            // Added For Contact
            if (this.entityTypeAttached == 2) {             
              for (var i = 0, len = this.getTaskAttachedEntityInDetails.length; i < len; ++i) {               
                if(this.getTaskAttachedEntityInDetails[i].attachedEntityEmail!=""){
                  this.repeatTaskEmail+= this.getTaskAttachedEntityInDetails[i].attachedEntityEmail+','; 
                }                
              }
            }

            // Added For Company
            if (this.entityTypeAttached == 3) {             
              for (var i = 0, len = this.getTaskAttachedEntityInDetails.length; i < len; ++i) {                
                if(this.getTaskAttachedEntityInDetails[i].attachedEntityEmail!=""){
                  this.repeatTaskEmail+= this.getTaskAttachedEntityInDetails[i].attachedEntityEmail+','; 
                }                
              }
            }           
          }        

         this.repeatTaskEmail=this.repeatTaskEmail.replace(/,(\s+)?$/, '');
         this.SubmitColumnsButton=true;
         this.loaderService.hide();
        }
        else {          
          this.loaderService.hide();
        }
      }
      else {       
        this.loaderService.hide();
      }
    });
  }

  onSendManualTaskReminder(){   
    if(this.repeatTaskEmail == ""){
      this.toastr.warning('Please add email id.', '', {
        timeOut: 3000,
      });
      return;
    }

    var check = this.repeatTaskEmail;
    var newcheck:any=[];
    newcheck=check.split(',');
    for(var i = 0; i < newcheck.length; i++) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var checkemail = re.test(String(newcheck[i]).toLowerCase());
      if (checkemail == true) {
      } else {
        this.toastr.warning('Please provide valid email.', '', {
          timeOut: 3000,
        });
        return;
      }
    }

    var reqModel={
      taskID: this.TaskReminderTaskId,   
      emails: this.repeatTaskEmail,       
      userID: this.currentUser.UID,  
      officeID: this.myOfficeID,    
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID:this.databaseId
    }    
    this.SubmitColumnsButton=false;    
    this.loaderService.show();
    this.taskService.SendManualTaskReminderService(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          this.toastr.success('Task reminder send successfully.', '', {
            timeOut: 3000,
          });
          this.closeSendReminder();
         } else {
          this.loaderService.hide();
          this.toastr.error('Task reminder failed.', '', {
            timeOut: 3000,
          });
          this.closeSendReminder();
        }
      } else {
        this.loaderService.hide();
        this.toastr.error('Task reminder failed.', '', {
          timeOut: 3000,
        });
        this.closeSendReminder();
      }
    });
  }





  ////=============== For Single Task =================//
  TaskIdForSingleTask:number=0;
  TaskTemplatesListForSingleTask:any=[]=[];
  TaskTemplatesListForSingleTaskFilter:any=[]=[];
  categoryTypeForSingleTask:number=0;
  taskTemplateIDForSingleTask:number=0;
  taskTemplateNameForSingleTask:string="";
  taskTitleForSingleTask:string="";
  selectedTemplate:any=[]=[];
  taskListIDforImportTask:number=0;

  OnCategoryChangeForSingleTask(categoryTypeValue: number) {
    this.categoryTypeForSingleTask = categoryTypeValue;
    this.selectedTaskCategoryID =0;
    this.getTaskTemplatesForSingleTask();  
  }


  SaveAsTemplateForSingleTask(templateRef: TemplateRef<any>, tasklist: any) {  
    this.categoryTypeForSingleTask=0;
    this.taskTemplateIDForSingleTask=0;
    this.AddTaskTemplateMultiple = false;
    this.taskTemplateNameForSingleTask="";
    this.TaskIdForSingleTask = tasklist.taskId;
    this.taskTitleForSingleTask=tasklist.taskTitle;
    this.createSaveAsTaskTemplate();   
    this.showNew = true;
    this.showExisting = false;   
    this.getActiveTaskTemplateCategories();
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  getTabDetailsForSingleTask(event) {
    this.updateTaskTemplateTasksButton = false;
    this.taslTemplateID = 0;
    this.selectedTemplate=[];
    this.createSaveAsTaskTemplate();
    if (event.tab.textLabel == "New" || event.index == 0) {
      this.showNew = true;
      this.showExisting = false;
    }

    if (event.tab.textLabel == "Update Existing" || event.index == 1) {
      this.showNew = false;
      this.showExisting = true;
      this.selectedTaskCategoryID=0;
      this.getTaskTemplatesForSingleTask();
    }
  }

  getSelectTaskCategoryForSingleTask(e: any) {
    this.selectedTaskCategoryID = e.value;
    this.updateTaskTemplateTasksButton = false;
    this.getTaskTemplatesForSingleTask();
  }

  getTaskTemplatesForSingleTask() {
    this.ShowNoRecordFoundTaskTemplates = false;
    this.loaderService.show();
    var ReqModel = {
      categoryID: Number(this.selectedTaskCategoryID),
      templateType: Number(this.categoryTypeForSingleTask),
      userID: this.currentUser.UID,
      officeID: Number(this.myOfficeID),
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.taskService.getSingleTaskTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.TaskTemplatesListForSingleTask = response.data.tasks;
          this.TaskTemplatesListForSingleTaskFilter= response.data.tasks;
          // if(this.categoryType==0){
          //   this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 0);
          //   const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
          //   this.FilteredTaskTemplatesList = this.TaskTemplatesListForSingleTask.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
          // }
          // if(this.categoryType==1){
          //   this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 1);
          //   const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
          //   this.FilteredTaskTemplatesList = this.TaskTemplatesListForSingleTask.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
          // }
          // if(this.categoryType==2){
          //   this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 2);
          //   const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
          //   this.FilteredTaskTemplatesList = this.TaskTemplatesListForSingleTask.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
          // }
          if (this.TaskTemplatesListForSingleTask.length > 0) {
            this.ShowNoRecordFoundTaskTemplates = false;
          } else {
            this.ShowNoRecordFoundTaskTemplates = true;
          }         
        }
        else {
          this.ShowNoRecordFoundTaskTemplates = true;
          this.TaskTemplatesListForSingleTask = [];
          this.loaderService.hide();
        }
      }
      else {
        this.TaskTemplatesListForSingleTask = [];
        this.ShowNoRecordFound = true;
        this.loaderService.hide();
      }
    });
  }


  SelectTemplateForAddTaskListForSingleTask(temp: any) {
    this.taskTemplateIDForSingleTask = temp.taskId;
    this.taskTemplateNameForSingleTask=temp.taskTitle;
    this.updateTaskTemplateTasksButton = true;
  }

  async AddSingleTaskTemplateForSingleTask(data) {  
    this.loaderService.show();
    var ReqModel = {
      taskID: this.TaskIdForSingleTask,
      singleTaskTemplateID:this.taskTemplateIDForSingleTask,
      templateName:this.taskTemplateNameForSingleTask,
      categoryID:this.categoryTypeForSingleTask, 
      templateType:Number(this.selectedTaskCategoryID),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    }
   // return; 
    this.spinner = true;
    this.updateTaskTemplateTasksButton = false;
    const result = await this.taskService.addSingleTaskTemplate(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
      this.toastr.success("Single task import successfully.", '', {
        timeOut: 3000,
      });   
      this.getTaskList(this.pageModelData);
      this.closeSaveAsTemplateForSingleTask();
    }
    else {
      this.toastr.error("Single task import failed.", '', {
        timeOut: 3000,
      });
      this.showMoveToOption = false;
      this.spinner = false;
      this.loaderService.hide();
    }
  }

  closeSaveAsTemplateForSingleTask(){
    this.taskTemplateIDForSingleTask = 0;
    this.addTemplateForm.reset();
    this.taskListFolderID = 0;
    this.dialog.closeAll();
  }


  async AddTaskTemplateForSingleTask(data) {  
    this.loaderService.show();
    var ReqModel = {
      taskID: this.TaskIdForSingleTask,
      singleTaskTemplateID: 0,
      templateName:data.taskTemplateName,
      categoryID: Number(data.folderID),
      templateType: this.categoryTypeForSingleTask,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    //return; 
    this.spinner = true;
    this.addTemplateForm.markAsPristine();
    const result = await this.taskService.addSingleTaskTemplate(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
      this.toastr.success("Task template added successfully.", '', {
        timeOut: 3000,
      });     
      this.closeSaveAsTemplateForSingleTask();
    }
    else {
      this.toastr.error("Task template add failed.", '', {
        timeOut: 3000,
      });     
      this.spinner = false;
      this.loaderService.hide();
    }
  }

//================Import Single Task ============//

  ImportTaskTemplate(templateRef: TemplateRef<any>) {
    this.AttachChecked=false;
    this.AssigneeChecked=false;
    this.NotifyChecked=false;
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
    this.categoryTypeForSingleTask=0;
    this.currentIndex=0;
    this.selectedTemplate=[];
    //this.taskListIDforImportTask=0;
    //this.taskListIDforAddTemplate = Number(list.taskListID);
    this.getTaskTemplatesForSingleTask();
    this.selectedTaskCategoryID = 0;
    this.categoryType=0;
    this.searchTemplateName = "";
    this.getActiveTaskTemplateCategories();
  }

  ImportTaskTemplateFromTaskList(templateRef: TemplateRef<any>,list:any) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
    this.AttachChecked=false;
    this.AssigneeChecked=false;
    this.NotifyChecked=false;
    this.categoryTypeForSingleTask=0;
    this.currentIndex=0;
    this.selectedTemplate=[];
    this.taskListIDforImportTask = Number(list.taskListID);
    this.getTaskTemplatesForSingleTask();
    this.selectedTaskCategoryID = 0;
    this.categoryType=0;
    this.searchTemplateName = "";
    this.getActiveTaskTemplateCategories();
  }

  

  onTaskListTabChangeForTaskImport($event) {
    this.selectedTemplate=[];
    this.selectedTaskCategoryID = 0;
    const textLabel = $event.value;
    const categoryValue = textLabel == 'My Template' ? 0 : (textLabel == 'Organization' ? 2 : 1);  
    this.categoryTypeForSingleTask=categoryValue;
    this.getTaskTemplatesForSingleTask();   
  }

  getTaskListThroughCategoryForTaskImport(e: any, i: any) {
    this.selectedTemplate=[];
    this.currentIndex = i
    this.selectedTaskCategoryID = e;
    this.getTaskTemplatesForSingleTask();  
  }

   //Checkbox Change detecting function
   getCheckboxValues(event, template) { 
    if (event.checked) {     
      this.selectedTemplate.push(template);     
    } else {
      let removeIndex = this.selectedTemplate.findIndex((itm) => itm === template);
      if (removeIndex !== -1) this.selectedTemplate.splice(removeIndex, 1);    
    }
    if(this.selectedTemplate.length == 0) {       
    }
   }
  

   async importTaskTemplates() {
    this.loaderService.show();
    var taskIdss=[];
    if (this.selectedTemplate.length > 0) {     
      for (let i = 0; i < this.selectedTemplate.length; i++) {      
        taskIdss.push(this.selectedTemplate[i].taskId);
      }
    }
    var taskListIDforImportTask=0;
    if(this.taskListIDforImportTask>0){
      taskListIDforImportTask=this.taskListIDforImportTask;
    }else{
      taskListIDforImportTask=0;
    }

    var ReqModel = {  
      taskIds: taskIdss,
      taskListID:Number(taskListIDforImportTask),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      keepAttached: false,//this.AttachChecked,
      keepAssignee: this.AssigneeChecked,
      keepNotify: this.NotifyChecked,
    }
    // return;
    this.spinner = true;
    const result = await this.taskService.importTaskFromTemplate(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();     
      this.toastr.success("Single Task Template Imported successfully.", '', {
        timeOut: 3000,
      });
      if(this.taskListIDSharedWithMe>0){
        this.getTaskByTaskListSharedWithMe();                  
      }
      if(this.taskListIDSharedWithMe==0){
        if (this.taskListID == 0) {
          this.getTaskList(this.pageModelData);
        } else {
          this.getTaskByTaskList();
        }  
      } 
      // if (this.taskListID == 0) {
      //   this.getTaskList(this.pageModelData);
      // }
      // if (this.taskListID > 0) {
      //   this.getTaskByTaskList();
      // }
      this.closeImportTaskTemplate();
    }
    else {
      this.toastr.error("Single Task Template Import failed.", '', {
        timeOut: 3000,
      });
      this.spinner = false;
      this.loaderService.hide();
    }
  }

  closeImportTaskTemplate() {
    this.selectedTemplate=[];
    this.taskListFolderID = 0;
   // this.taskListIDforImportTask=0;
    this.selectedTaskCategoryID = 0;
    this.searchTemplateName = "";
    this.categoryType=0;
    this.dialog.closeAll();
  }

  searchTemplateForSingleTask(val) {
    if (val.length >= 2) {
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {      
        this.selectedTemplate=[];
        this.TaskTemplatesListForSingleTask = this.TaskTemplatesListForSingleTaskFilter.filter(i => i.templateName.toLowerCase().indexOf(val.toLocaleLowerCase()) !== -1);
        }, 500);
      } else {

      }
    } else {
      this.selectedTemplate=[];
      this.searchTemplateName = "";  
      this.getTaskTemplatesForSingleTask();    
    }
  }


  // ======== Archived ============//

  currentTaskListArchived: number = 0;
  taskListSelectedArchived = false;
  taskListsArchived: any = [] = [];
  expandedIndexArchived: number = 0;
  taskListIDArchived: number = 0;

  getTaskLists1Archived(tasklist: any, index: number) {
    if(tasklist.id==1){
    if (this.currentTaskListArchived == index) {
      this.taskListSelectedArchived = !this.taskListSelectedArchived;
    } else {
      this.taskListSelectedArchived = true;
    }

    this.currentTaskListArchived = index;
    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    this.showMoveToOption = false;
    this.expandedIndexArchived = index;
  //  this.dueDatetext = 'Due Date';
   // this.preoritytext = "Priority";
   // this.myTaskText = "Task";
    this.taskListsArchived=[];
    }
   // this.taskListFolderID = tasklist.id;
  }

  SingleTaskArchived:boolean=false;

  getTaskListsArchived(tasklist: any, index: number) {

    if(tasklist.id==1){
    if (this.currentTaskListArchived == index) {
      this.taskListSelectedArchived = !this.taskListSelectedArchived;
    } else {
      this.taskListSelectedArchived = true;
    }

    this.currentTaskListArchived = index;
    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    this.showMoveToOption = false;
    this.taskListsArchived = [];
    this.expandedIndexArchived = index;
  
   // this.dueDatetext = 'Due Date';
   // this.preoritytext = "Priority";
   // this.myTaskText = "Task";
    //this.taskListFolderID = tasklist.id;
    this.getArchivedTaskLists();
    // if(tasklist.id==1){
    //   this.getArchivedTaskLists();
    // }  
    }
    if(tasklist.id==2){
      this.pageIndex=1;
      this.pageSize=30;
      this.IsAssignedToMe = false;
      this.IsAssignedToMyRole = false;
      this.IsCreatedByMe = false;
      this.IsAllTask = true;
      this.getTaskList(true);
    }  
  }

  getArchivedTaskLists(){
    var ReqModel = {      
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getArchivedTaskLists(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;     
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskListsArchived = response.data.taskLists;          
        }
        else {
          this.taskListsArchived = [];         
        }
      }
      else {
        this.taskListsArchived = [];       
      }
    });
  }

  
  OpenTaskListArchived(Tasklist: any) {
    this.showAddGroupButton = false;
    this.taskListIDArchived = Tasklist.taskListID;
    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    this.showMoveToOption = false;
    //this.dueDatetext = 'Due Date';
   // this.preoritytext = "Priority";
   // this.myTaskText = "Task";
    this.getTaskByTaskListArchived();
  }

  getTaskByTaskListArchived() {   
    this.statustext = 'Status';
    this.dueDatetext = 'Due Date';
    this.isDuedate = false;
    this.isOverDue = false;
    this.dateFrom = null;
    this.dateTo = null;
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.preorityArray = [];
    this.IsAssignedToMe = false;
    this.IsAssignedToMyRole = false;
    this.IsCreatedByMe = false;
    this.IsAllTask = false;
    this.isMyTaskFilterSelected = false;
    this.statustype = 0;
    this.ShowNoRecordFound = false;
    this.loaderService.show();
    var ReqModel = {
      taskListID: Number(this.taskListIDArchived),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      moduleID: Number(this.folderId)
    }
    this.taskService.GetTaskGroupsByTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.ShowCustomColumn = true;
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.dataSource = new MatTableDataSource<any>();
          this.myTaskText = response.data.taskListName;
          this.columns = JSON.parse(JSON.stringify(this.columnsCopy));
          if (response.data.taskGroups !== undefined && response.data.taskGroups !== null) {
            response.data.taskGroups = response.data.taskGroups.sort(function (a, b) {
              return a.groupPosition - b.groupPosition;
            });

            const taskFil = response.data.taskGroups.filter(x => x.tasks.length > 0)
            taskFil.map(data => {
              data.tasks.forEach(state => {
                this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

                if (state.status == 0) {
                  this.statusGroup.controls["status" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["status" + state.taskId].setValue(state.status);
                }
                this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

                if (state.priority == 0) {
                  this.statusGroup.controls["priority" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
                }
                if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
                //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                state.dueDate = state.dueDate+'.000Z';
               }
              })
            })

            response.data.taskGroups.forEach(tg => {

              if (tg.tasks !== undefined && tg.tasks !== null) {
                tg.tasks.forEach(ts => {
                  ts.formLink = this.reSetFormURL(ts.taskId, ts.formLink);
                  if (ts.dueDate!=null && ts.dueDate!=undefined && ts.dueDate!="") {
                    ts.dueDate = moment(ts.dueDate).local().format('YYYY-MM-DD');
                 }
                });
                tg.tasks = tg.tasks.sort(function (a, b) {
                  return a.position - b.position;
                });
              }
              this.columns[0].groups.push({
                id: tg.taskGroupId,
                title: tg.taskGroupName == "Undefined" ? 'Default Group' : tg.taskGroupName,
                items: tg.tasks,
                dragDisabled: tg.taskGroupName == "Undefined" ? true : false,
                groupPosition: tg.groupPosition,
                processStageID:tg.processStageID,
                processStageName:tg.processStageName,
                isTriggered:tg.isTriggered,
                groupType:tg.groupType
              });
            });
          }

          this.taskList = response.data.getTaskDetailResponseDTOs;
          this.FieldColumnToogle = response.data.gridSettings;
          this.FieldColumn = response.data.gridSettings;

          if (this.FieldColumn.length > 0) {
            this.FieldColumn = this.FieldColumn.filter(x => x.isDisplay == true);
          }

          if (response.data.taskGroups.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }

          if (response.data.taskGroups.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }          
        }
        else {
          this.paginatorTotalLength = 0;
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }

getType(item: any){
  if(item && item[0]?.entityTypeAttached == 0){
   return 'app_registration'
  }
  else if(item && item[0]?.entityTypeAttached == 1){
    return 'contact_mail'
   }
   else if(item && item[0]?.entityTypeAttached == 3){
    return 'business'
   }else{
    return "-"
   }
}

getAttach(item: any){

   const allAttach = [];
   if(item){
     item.forEach(item => {
       allAttach.push(item.attachedEntityName);
     })
   }
   return allAttach ? allAttach : "-"

   //return item[0]?.attachedEntityName ? item[0]?.attachedEntityName : "-"
 }

 getAssigne(item: any){
   const allAssignee = [];
   if(item && item.length > 1){
     item.forEach(item => {
       if(item.assigneeName){
         allAssignee.push({name: item.assigneeName, image: item.imageUrl});
       }else if(item.roleName){
         allAssignee.push({name: item.roleName, image: item.imageUrl});
       }else if(item.email){
         allAssignee.push({name: item.email, image: item.imageUrl});
       }

       
     })
   }else{
     if(item[0]?.assigneeName){
       allAssignee.push({name: item[0].assigneeName, image: item[0].imageUrl});
     }else if(item[0]?.roleName){
       allAssignee.push({name: item[0].roleName, image: item[0].imageUrl});
     }else if(item[0]?.email){
       allAssignee.push({name: item[0].email, image: item[0].imageUrl});
     }

   }
   return allAssignee
 }

 getShortName(fullName) {
   if (fullName != undefined) {
     if (fullName.includes(' ')) {
       return fullName
         .split(' ')
         .map((n) => n[0])
         .join('');
     }
     return fullName.substring(0, 1);
   }
   return '';
 }
 
 getImageUrlPath(Imagepath) {

     if(Imagepath){
       return Imagepath
     }
     return '';
 }

 trackByFn(index, item) {
   return index; // or item.id
 }

  showOptions(event:MatCheckboxChange,data): void {
    if(data=="Attach"){
     this.AttachChecked=event.checked;
    }
    if(data=="Assignee"){
      this.AssigneeChecked=event.checked;
    }
    if(data=="Notify"){
      this.NotifyChecked=event.checked;
    }
  }

  MakeTaskRequired(task: any,isRequired) {   
      this.loaderService.show();
      var ReqModel = {
        taskIDs: [task.taskId],
        isRequired:isRequired,
        userID: this.currentUser.UID,
        officeID: this.myOfficeID,
        organizationID: Number(this.organizationId),     
        databaseID: this.databaseId
      }
      this.taskService.makeTaskRequired(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            task.isRequired = true;
            if(isRequired==true){
              this.toastr.success("Task required successfully.");
            }
            if(isRequired==false){
              this.toastr.success("Task unrequired successfully.");
            }
            if(this.taskListIDSharedWithMe>0){
              this.getTaskByTaskListSharedWithMe();                  
            }
            if(this.taskListIDSharedWithMe==0){
              if (this.taskListID == 0) {
                this.getTaskList(this.pageModelData);
              } else {
                this.getTaskByTaskList();
              }  
            } 
            // if (this.taskListID == 0) {
            //   this.getTaskList(this.pageModelData);
            // }
            // if (this.taskListID > 0) {
            //   this.getTaskByTaskList();
            // }
          }else {
            this.loaderService.hide();
          }
        }else {
          this.loaderService.hide();
        }
      });
  }   

  multipleMakeTaskRequired() {  
    const message = `Are you sure you want to required selected tasks ?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
        if(this.selectedRecordMoveToArray.length>0){
      //    var checkisRequiredTrue=[];
       var checkisRequiredFalse=[];

      // checkisRequiredTrue = this.selectedRecordMoveToArray.filter(x=>x.isRequired==true);
      // if(checkisRequiredTrue.length>0){
      //   var selectedtasklist = [];
      //   if (checkisRequiredTrue.length > 0) {
      //     for (var i = 0, len = checkisRequiredTrue.length; i < len; ++i) {
      //       const taskid = checkisRequiredTrue[i].selectedRecord;
      //       selectedtasklist.push(taskid);
      //     }
      //     this.MakeMultipleisRequiredFalse(selectedtasklist);
      //   }
      // }
      checkisRequiredFalse = this.selectedRecordMoveToArray;//.filter(x=>x.isRequired==false);
      if(checkisRequiredFalse.length>0){
        var selectedtasklist = [];
        if (checkisRequiredFalse.length > 0) {
          for (var i = 0, len = checkisRequiredFalse.length; i < len; ++i) {
            const taskid = checkisRequiredFalse[i].selectedRecord;
            selectedtasklist.push(taskid);
          }
          this.MakeMultipleisRequiredTrue(selectedtasklist);
        }
      }
    }   
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
    
  }  

  multipleMakeTaskUnRequired() {  
    const message = `Are you sure you want to unrequired selected tasks ?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
        if(this.selectedRecordMoveToArray.length>0){
      var checkisRequiredTrue=[];
      //var checkisRequiredFalse=[];

      checkisRequiredTrue = this.selectedRecordMoveToArray;//.filter(x=>x.isRequired==true);
      if(checkisRequiredTrue.length>0){
        var selectedtasklist = [];
        if (checkisRequiredTrue.length > 0) {
          for (var i = 0, len = checkisRequiredTrue.length; i < len; ++i) {
            const taskid = checkisRequiredTrue[i].selectedRecord;
            selectedtasklist.push(taskid);
          }
          this.MakeMultipleisRequiredFalse(selectedtasklist);
        }
      }
      // checkisRequiredFalse = this.selectedRecordMoveToArray.filter(x=>x.isRequired==false);
      // if(checkisRequiredFalse.length>0){
      //   var selectedtasklist = [];
      //   if (checkisRequiredFalse.length > 0) {
      //     for (var i = 0, len = checkisRequiredFalse.length; i < len; ++i) {
      //       const taskid = checkisRequiredFalse[i].selectedRecord;
      //       selectedtasklist.push(taskid);
      //     }
      //     this.MakeMultipleisRequiredTrue(selectedtasklist);
      //   }
      // }
    }   
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
    
  }  

  MakeMultipleisRequiredTrue(selectedtasklist){
    this.loaderService.show();
    var ReqModel = {
      taskIDs: selectedtasklist,
      isRequired:true,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),     
      databaseID: this.databaseId
    }
    this.taskService.makeTaskRequired(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          // task.isRequired = true;         
          this.toastr.success("Task required successfully.");    
          if(this.taskListIDSharedWithMe>0){
            this.getTaskByTaskListSharedWithMe();                  
          }
          if(this.taskListIDSharedWithMe==0){
            if (this.taskListID == 0) {
              this.getTaskList(this.pageModelData);
            } else {
              this.getTaskByTaskList();
            }  
          }           
          // if (this.taskListID == 0) {
          //   this.getTaskList(this.pageModelData);
          // }
          // if (this.taskListID > 0) {
          //   this.getTaskByTaskList();
          // }
          this.showMoveToOption = false;
          this.selectedRecordMoveToArray = [];
          this.selection.clear();
          this.loaderService.hide();
        }else {
          this.loaderService.hide();
        }
      }else {
        this.loaderService.hide();
      }
    }); 
  }
 
  MakeMultipleisRequiredFalse(selectedtasklist){
    this.loaderService.show();
    var ReqModel = {
      taskIDs: selectedtasklist,
      isRequired:false,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),     
      databaseID: this.databaseId
    }
    this.taskService.makeTaskRequired(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          // task.isRequired = true;         
          this.toastr.success("Task unrequired successfully."); 
          if(this.taskListIDSharedWithMe>0){
            this.getTaskByTaskListSharedWithMe();                  
          }
          if(this.taskListIDSharedWithMe==0){
            if (this.taskListID == 0) {
              this.getTaskList(this.pageModelData);
            } else {
              this.getTaskByTaskList();
            }  
          }              
          // if (this.taskListID == 0) {
          //   this.getTaskList(this.pageModelData);
          // }
          // if (this.taskListID > 0) {
          //   this.getTaskByTaskList();
          // }
          this.showMoveToOption = false;
          this.selectedRecordMoveToArray = [];
          this.selection.clear();
          this.loaderService.hide();
        }else {
          this.loaderService.hide();
        }
      }else {
        this.loaderService.hide();
      }
    }); 
  }

  
  TriggerTaskGroup(task:any) {   
    const message = `Are you sure you want to trigger this task group?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var newTaskListGroup=[];

           if(task.groupType==1){
            this.taskListForGroupTrigger;
            var index = this.taskListForGroupTrigger.findIndex(x => x.taskGroupId === task.id);          
            if(this.taskListForGroupTrigger.length>0){
              var nexttIndex =index - 1;
              for (var i2 = nexttIndex; i2 >= 0; --i2){
                if(i2>0){
                if(this.taskListForGroupTrigger[i2].taskGroupId!=0){
                  var obj={
                    groupPosition:this.taskListForGroupTrigger[i2].groupPosition,
                    groupType:this.taskListForGroupTrigger[i2].groupType,
                    isTriggered:this.taskListForGroupTrigger[i2].isTriggered,
                    taskGroupId:this.taskListForGroupTrigger[i2].taskGroupId,
                    taskGroupName:this.taskListForGroupTrigger[i2].taskGroupName,
                  } 
                  newTaskListGroup.push(obj);
                }
               }           
              }             
            }          
           }
           if(newTaskListGroup.length>0){
              if(newTaskListGroup.length==1){
                var data=[];
                 //data =newTaskListGroup.filter(x=> x.groupType==0 && x.isTriggered==false);
                 data =newTaskListGroup.filter(x=> (x.isTriggered==true) || (x.groupType==0 && x.isTriggered==false));
               // data =newTaskListGroup.filter(x=> x.groupType==0 && x.isTriggered==false);
                if(data.length==0){
                  this.toastr.warning("Please Trigger Previous Group.");
                  return;
                }
              }
              if(newTaskListGroup.length>1){
                var checkData=[];
                checkData = newTaskListGroup.filter(x=> x.groupPosition==(task.groupPosition-1))
                checkData = checkData.filter(x=> x.isTriggered==true);
                //checkData = checkData.filter(x=> x.isTriggered==false);
                if(checkData.length==0){
                  this.toastr.warning("Please Trigger Previous Group.");
                  return;
                }
              }
           }
          this.loaderService.show();
          var taskListIDs:number=0
          if(this.taskListIDSharedWithMe>0){
            taskListIDs=this.taskListIDSharedWithMe;
          }
          if(this.taskListID>0){
            taskListIDs=this.taskListID;
          }
          var ReqModel = {
            taskListID: taskListIDs,//this.taskListID,
            taskGroupID:task.id,
            isTriggered:true,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),     
            databaseID: this.databaseId
         }
        this.taskService.triggerTaskGroup(ReqModel).subscribe(response => {
         if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {             
            this.toastr.success("Task Group Trigger successfully.");
            if(this.taskListIDSharedWithMe>0){
              this.getTaskByTaskListSharedWithMe();                  
            }
            if(this.taskListIDSharedWithMe==0){
              this.getTaskByTaskList();
            } 
            //this.getTaskByTaskList();
           }else {
            this.loaderService.hide();
           }
          }else {
            this.loaderService.hide();
           }
         });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  ChangeGroupType(event: MatRadioChange,task: any,groupType) {  
    var message;
    if(groupType==0){
      message = `Are you sure you want to change group type as normal for this group? and this changed will be set for all previous groups`;
    }
    if(groupType==1){
      message = `Are you sure you want to change group type as trigger for this group? and this changed will be set for all next groups`;
    }   
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          var taskListIDs:number=0
          if(this.taskListIDSharedWithMe>0){
             taskListIDs=this.taskListIDSharedWithMe;
            }
          if(this.taskListID>0){
            taskListIDs=this.taskListID;
           }

          var ReqModel = {
          groupID: task.id,
          taskListID: taskListIDs,//this.taskListID,
          groupType: groupType,
          userID: this.currentUser.UID,
          officeID: this.myOfficeID,
          organizationID: Number(this.organizationId),     
          databaseID: this.databaseId
       }
      this.taskService.changeGroupType(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {             
          this.toastr.success("Task Group Trigger successfully.");      
          if(this.taskListIDSharedWithMe>0){
            this.getTaskByTaskListSharedWithMe();
          }else{
            this.getTaskByTaskList();
          }  

         // this.getTaskByTaskList();

          // 1 For set Trigger
          if(groupType==1){
            this.taskListForGroupTrigger;
            var index = this.taskListForGroupTrigger.findIndex(x => x.taskGroupId === task.id);           
            var newTaskListGroup=[];
            if(this.taskListForGroupTrigger.length>0){
              var nextIndex =index + 1;
              for (var i = nextIndex, len = this.taskListForGroupTrigger.length; i < len; ++i) {
                if(this.taskListForGroupTrigger[i].groupType==0){
                  var obj={
                    groupPosition:this.taskListForGroupTrigger[i].groupPosition,
                    groupType:this.taskListForGroupTrigger[i].groupType,
                    isTriggered:this.taskListForGroupTrigger[i].isTriggered,
                    taskGroupId:this.taskListForGroupTrigger[i].taskGroupId,
                    taskGroupName:this.taskListForGroupTrigger[i].taskGroupName,
                  } 
                  newTaskListGroup.push(obj);
                }               
              }
              if(newTaskListGroup.length>0){
               for (var i1 = 0, len1 = newTaskListGroup.length; i1 < len1; ++i1) {
                 this.ChangeGroupTypeMultiple(newTaskListGroup[i1],1); //1 For set Trigger
               }
              }
            }          
          }
           // 0 For set Normal
          if(groupType==0){
            this.taskListForGroupTrigger;
            var index = this.taskListForGroupTrigger.findIndex(x => x.taskGroupId === task.id);           
            var newTaskListGroup=[];
            if(this.taskListForGroupTrigger.length>0){
              var nexttIndex =index - 1;
              for (var i2 = nexttIndex; i2 >= 0; --i2){
                if(i2>0){
                if(this.taskListForGroupTrigger[i2].taskGroupId!=0){
                  var obj={
                    groupPosition:this.taskListForGroupTrigger[i2].groupPosition,
                    groupType:this.taskListForGroupTrigger[i2].groupType,
                    isTriggered:this.taskListForGroupTrigger[i2].isTriggered,
                    taskGroupId:this.taskListForGroupTrigger[i2].taskGroupId,
                    taskGroupName:this.taskListForGroupTrigger[i2].taskGroupName,
                  } 
                  newTaskListGroup.push(obj);
                }
               }           
              }
              if(newTaskListGroup.length>0){
               for (var i1 = 0, len1 = newTaskListGroup.length; i1 < len1; ++i1) {
                 this.ChangeGroupTypeMultiple(newTaskListGroup[i1],0); //0 For set Normal
               }
              }
            }          
          }
        }else {
          this.loaderService.hide();
        }
         }else {
          this.loaderService.hide();
         }
        });
       }
      } catch (e) {
        Observable.throw(e);
      }
    });    
  } 

  ChangeGroupTypeMultiple(task: any,groupType) { 
    //this.loaderService.show();
    var taskListIDs:number=0
    if(this.taskListIDSharedWithMe>0){
      taskListIDs=this.taskListIDSharedWithMe;
    }
    if(this.taskListID>0){
      taskListIDs=this.taskListID;
    }
    var ReqModel = {     
      groupID: task.taskGroupId,
      taskListID: taskListIDs,//this.taskListID,
      groupType: groupType,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),     
      databaseID: this.databaseId
    }
    this.taskService.changeGroupType(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;       
        if (this.responseHolder.status == this.statusConst.statusSuccess) { 
          if(this.taskListIDSharedWithMe>0){
            this.getTaskByTaskListSharedWithMe();
          }else{
            this.getTaskByTaskList();
          }             
         // this.getTaskByTaskList();         
        }else {        
        }
      }else {       
      }
    });
  }

  multipleMakeTaskExternalInternal(isInternal) {
    var message;
    if(isInternal==false){
      message = `Are you sure you want to make external selected tasks ?`;
    }
    if(isInternal==true){
      message = `Are you sure you want to make internal selected tasks ?`;
    }
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
        if(this.selectedRecordMoveToArray.length>0){
         var checkisRequiredTrue=[];    

        checkisRequiredTrue = this.selectedRecordMoveToArray;//.filter(x=>x.isRequired==true);
        if(checkisRequiredTrue.length>0){
        var selectedtasklist = [];
        if (checkisRequiredTrue.length > 0) {
          for (var i = 0, len = checkisRequiredTrue.length; i < len; ++i) {
            const taskid = checkisRequiredTrue[i].selectedRecord;
            selectedtasklist.push(taskid);
          }
          this.MakeMultipleTaskExternalInternal(selectedtasklist,isInternal);
          }
        }     
       }   
      }
      } catch (e) {
        Observable.throw(e);
      }
    });
    
  } 

  MakeMultipleTaskExternalInternal(selectedtasklist,isInternal){
    this.loaderService.show();
    var ReqModel = {
      taskIDs: selectedtasklist,
      isInternal:isInternal,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),     
      databaseID: this.databaseId
    }
    this.taskService.makeTaskExternal(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if(isInternal==false){
            this.toastr.success("Task External successfully.");   
          }          
          
          if(isInternal==true){
            this.toastr.success("Task Internal successfully.");   
          } 
          if(this.taskListIDSharedWithMe>0){
            this.getTaskByTaskListSharedWithMe();                  
          }
          if(this.taskListIDSharedWithMe==0){
            if (this.taskListID == 0) {
              this.getTaskList(this.pageModelData);
            } else {
              this.getTaskByTaskList();
            }  
          } 
          // if (this.taskListID == 0) {
          //   this.getTaskList(this.pageModelData);
          // }
          // if (this.taskListID > 0) {
          //   this.getTaskByTaskList();
          // }
          this.showMoveToOption = false;
          this.selectedRecordMoveToArray = [];
          this.selection.clear();
          this.loaderService.hide();
        }else {
          this.loaderService.hide();
        }
      }else {
        this.loaderService.hide();
      }
    }); 
  }

  taskSubFolderList:any=[]=[];
  taskTypeID:number=0;

  getDrpFields(event: { value: number; }) {
    if(event != undefined) {
     this.taskTypeID = event.value;
    }
  }

  getTaskSubFolderList(){
    var ReqModel = {  
      folderID: this.folderId,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),     
      databaseID: Number(this.databaseId)
    }
    this.taskService.getAllSubFoldersForFolder(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;       
        if (this.responseHolder.status == this.statusConst.statusSuccess) {   
          if(this.responseHolder.data.length>0){
            this.taskSubFolderList =  this.responseHolder.data.filter(x=>x.isActive==true);
          }         
        }else {
          this.taskSubFolderList =[];
        }
      }else {
        this.taskSubFolderList =[];
      }
    });
  }

   selectStagePopUp(task: any) {
       var taskListIDs:number=0
       if(this.taskListIDSharedWithMe>0){
            taskListIDs=this.taskListIDSharedWithMe;
        }
        if(this.taskListID>0){
          taskListIDs=this.taskListID;
        }
        const dialogRef = this.dialog.open(AddUpdateProcessStageComponent, {
          data: {
            tasklistID:taskListIDs,
            tasklistGroupID:task.id,
            AddFrom:"TaskList Group"            
          }     
        });
        dialogRef.afterClosed().subscribe(result => {
          if(result!=null && result!=undefined){
             if(this.taskListIDSharedWithMe>0){
            this.getTaskByTaskListSharedWithMe();                  
          }
          if(this.taskListIDSharedWithMe==0){
            if (this.taskListID == 0) {
              this.getTaskList(this.pageModelData);
            } else {
              this.getTaskByTaskList();
            }  
          }  
          }  
        });     
    }

    deleteprocessStage(data: any) {
        var message = `Are you sure you want to remove?`;  
        const title = `Confirm Remove`;
        const confirm = `Remove`;
        const dialogData = new ConfirmDialogModel(title, message,confirm);
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          panelClass: 'edituserdetails',
          maxWidth: '1000px',
          maxHeight: '500px',
          data: dialogData
        });  
        dialogRef.beforeClosed().subscribe(async dialogResult => {
          if (dialogResult) {
            this.loaderService.show();   
            var taskListIDs:number=0
            if(this.taskListIDSharedWithMe>0){
             taskListIDs=this.taskListIDSharedWithMe;
             }
             if(this.taskListID>0){
             taskListIDs=this.taskListID;
             }    
            var ReqModel ={
              tasklistID: Number(taskListIDs),
              tasklistGroupID:Number(data.id),
              processStageID: 0,
              userID: this.currentUser.UID,
              organizationID: Number(this.organizationId),
              databaseID: Number(this.databaseId),
              officeID: this.myOfficeID,
              officeIDList: this.OfficeIDList
            }        
            this.taskService.setProcessStageforTasklistGroup(ReqModel).subscribe(response => {
              if (response != undefined) {
                this.responseHolder = response;
                this.loaderService.hide();
                if (this.responseHolder.status == this.statusConst.statusSuccess) {
                  this.toastr.success('Stage remove successfully.', '', {
                    timeOut: 3000,
                  });
                  if(this.taskListIDSharedWithMe>0){
                   this.getTaskByTaskListSharedWithMe();                  
                   }
                 if(this.taskListIDSharedWithMe==0){
                  if (this.taskListID == 0) {
                   this.getTaskList(this.pageModelData);
                    } else {
                   this.getTaskByTaskList();
                   }  
                  } 
                  this.loaderService.hide();
                }
              }
            });
          }
        });
       }  
  
}
  

